import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpResponse, HttpParams } from "@angular/common/http";
import { Student } from "../student";
import { Observable, ObservedValueOf, of } from "rxjs";
import { Booking } from "../booking";
import { UsernamePassword } from "../username-password";
import { SchoolInfo } from "../school-info";
import { AuthenticatedHttpClient } from "../authenticated-http-client";
import { MedicalInfo } from "../medical-info";
import { Vademecum } from "../vademecum";
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { BookingWithVademecum } from '../booking-with-vademecum';
import { Role } from '../role';
import { EmailTemplate } from '../email-template';
import { TemplateLink } from '../template-link';
import { School } from '../school';
import { Guide } from '../guide';
import { CallSummary } from '../call-summary';
import { InterestLevel } from '../interest-level';
import { Promotion } from '../promotion';
import { StudyProgram } from '../study-program';
import { EtcParentalPermission } from '../etc-parental-permission';
import { Gender } from '../gender';
import { Nationality } from '../nationality';
import { EtcStudentParentLanguage } from '../etc-student-parent-language';
import { KanbanList } from '../kanban-list';
import { LinkItem } from '../link-item';
import { GmailMessage } from '../gmail-message';
import { SchoolComment } from '../school-comment';
import { AuditUpdate } from '../audit-update';
import { CallSummaryComment } from '../call-summary-comment';
import { WpTranslationItem } from '../wp-translation-item';
import { ContactRequest } from '../contact-request';
import { UserForBackend } from '../user-for-backend';
import { RefundRequest } from '../refund-request';
import { Currency } from '../currency';
import { BookingReportTemplate } from '../booking-report-template';
import { WpBookingRequest } from '../wp-booking-request';
import { Country } from '../country';
import { WpContactRequest } from '../wp-contact-request';
import { WpContactRequestComment } from '../wp-contact-request-comment';
import { ConstantContactListList } from '../constant-contact-list-list';
import { ConstantContactContactJson } from '../constant-contact-contact-json';
import { WpContactRequestResponse } from '../wp-contact-request-response';
import { SalesAgent } from '../sales-agent';
import { BookingConfirmation } from '../booking-confirmation';
import { SalesProductType } from '../sales-product-type';
import { PaymentReceived } from '../payment-received';
import { PaymentType } from '../payment-type';
import { SchoolInvoice } from '../school-invoice';
import { PaymentToSupplier } from '../payment-to-supplier';
import Decimal from 'decimal.js';
import { ExchangeRate } from '../exchange-rate';
import { Region } from '../region';
import { InternalBookingComment } from '../internal-booking-comment';
import { TargetLanguageLevel } from '../target-language-level';
import { AccommodationType } from '../accommodation-type';
import { RoomType } from '../room-type';
import { BoardType } from '../board-type';
import { TravelType } from '../travel-type';
import { TransportType } from '../transport-type';
import { TransferType } from '../transfer-type';
import { Language } from '../language';
import { LanguageCourse } from '../language-course';
import { StudentComment } from '../student-comment';
import { SearchOperator } from '../search-operator';
import { SearchAction } from '../search-action';
import { SearchColumn } from '../search-column';
import { SearchRule } from '../search-rule';
import { SavedSearch } from '../saved-search';
import { BookingFile } from '../booking-file';
import { BookingReport } from '../booking-report';
import { PaymentReceivedWithBooking } from '../payment-received-with-booking';
import { DateRange } from '../date-range';
import { PdfDocumentTemplateCss } from '../pdf-document-template-css';
import { SimpleBrugesVndBooking } from '../simple-bruges-vnd-booking';
import { BasicBrugesVndBooking } from '../basic-bruges-vnd-booking';
import { BookingQuotation } from '../booking-quotation';
import { ContactRequestPdfTemplate } from "../contact-request-pdf-template";
import { PdfDocumentCategory } from "../pdf-document-category";
import { BookingQuotationWithDetail } from "../booking-quotation-with-detail";
import { ContactRequestComment } from "../contact-request-comment";
import { ContactRequestQuotationWithDetail } from "../contact-request-quotation-with-detail";
import { ContactRequestQuotation } from "../contact-request-quotation";
import { QuotationRequest } from "../quotation-request";
import { Lead } from "../lead";
import { LeadType } from "../lead-type";
import { ProgrammeType } from "../programme-type";
import { AppointmentRequest } from "../appointment-request";
import { QuotationTemplate } from "../quotation-template";
import { QuotationTemplateWithDetail } from "../quotation-template-with-detail";
import { SiepSalonContact } from "../siep-salon-contact";
import { SalesInvoiceWithNewNumber } from "../billing/sales-invoice-with-new-number";
import { VatRate } from "../billing/vat-rate";
import { InvoiceReceiver } from "../billing/invoice-receiver";
import { SalesInvoice } from "../billing/sales-invoice";
import { PdfDocumentHeaderFooter } from "../pdf-document-header-footer";
import { LeadEmailTemplate } from "../lead-email-template";
import { LeadStatus } from "../lead-status";
import { SchoolDocumentFile } from "../school-document-file";
import { ConstantContactContact } from "../constant-contact-contact";
import { ConstantContactContactList } from "../constant-contact-contact-list";
import { ConstantContactContactPostRequest } from "../constant-contact-contact-post-request";
import { ConstantContactContactPutRequest } from "../constant-contact-contact-put-request";
import { EmailSignature } from "../email-signature";
import { SchoolContact } from "../school-contact";
import { SchoolContactType } from "../school-contact-type";
import { SchoolFile } from "../school-file";
import { SchoolLviUrl } from "../school-lvi-url";
import { SchoolWithDetail } from "../school-with-detail";
import { AppointmentType } from "../appointment-type";
import { BookingFileType } from "../booking-file-type";
import { GlobalBookingFile } from "../global-booking-file";
import { GmailMessageWithBookingFiles } from "../gmail-message-with-booking-files";
import { BookingEmailTemplate } from "../booking-email-template";
import { SimpleBookingEmailTemplate } from "../simple-booking-email-template";
import { CustomCsvExportConfiguration } from "../custom-csv-export-configuration";
import { BookingStatsLineItem } from "../booking-stats-line-item";
import { BookingPreConfirmation } from "../booking-pre-confirmation";
import { BookingPreConfirmationTemplate } from "../booking-pre-confirmation-template";
import { SimpleBookingPreConfirmation } from "../simple-booking-pre-confirmation";
import { LviBankInformation } from "../lvi-bank-information";
import { SchoolInvoiceWithPayments } from "../school-invoice-with-payments";
import { LeadSearchResult } from "../lead-search-result";
import { ContactRequestEmailHistory } from "../contact-request-email-history";
import { StudentContactType } from "../student-contact-type";
import { StudentContact } from "../student-contact";
import { EtcBooking } from "../etc-booking";
import { SimpleUser } from "../simple-user";
import { PaymentReceivedLineItem } from "../payment-received-line-item";
import { PaymentReceivedSearchRules } from "../payment-received-search-rules";
import { SimpleBooking } from "../simple-booking";
import { LeadSearchOptions } from "../lead-search-options";
import { WpBookingRequestSearchOptions } from "../wp-booking-request-search-options";
import { WpBookingRequestComment } from "../wp-booking-request-comment";
import { ProgrammeInformation } from "../programme-information";
import { SchoolInvoiceWithPaymentOrders } from "../school-invoice-with-payment-orders";
import { BookingRequestToApprove } from "../booking-request-to-approve";
import { BookingTempUserLog } from "../booking-temp-user-log";
import { BookingStatus } from "../booking-status";
import { BookingClientFile } from "../booking-client-file";
import { SchoolInvoiceWithPaymentOrdersListItem } from "../school-invoice-with-payment-orders-list-item";
import { BookingClientFileOpen } from "../booking-client-file-open";
import { BookingChat } from "../booking-chat";
import { RecaptchaUserResponse } from "../recaptcha-user-response";
import { OpenBookingInformation } from "../open-booking-information";
import { BookingSchoolFile } from "../booking-school-file";
import { FileType } from "../file-type";
import { BookingGlobalFile } from "../booking-global-file";
import { OpenSchoolFile } from "../open-school-file";
import { OpenGlobalFile } from "../open-global-file";
import { OpenBookingFile } from "../open-booking-file";
import { BookingAttachmentFile } from "../booking-attachment-file";
import { SchoolListItem } from "../school-list-item";
import { BookingFinalConfirmation } from "../booking-final-confirmation";
import { BookingConfirmationTemplate } from "../booking-confirmation-template";
import { BookingFinalConfirmationTemplate } from "../booking-final-confirmation-template";
import { TravelRequestCode } from "../travel-request-code";
import { MotherLanguage } from "../mother-language";
import { Accommodation } from "../accommodation";
import { BookingFinalConfirmationTemplateWithDetail } from "../booking-final-confirmation-template-with-detail";
import { BookingConfirmationTemplateWithDetail } from "../booking-confirmation-template-with-detail";
import { InsuranceSupplier } from "../insurance-supplier";
import { BookingListItem } from "../booking-list-item";
import { SchoolInvoicePost } from "../school-invoice-post";
import { BookingEmailHistory } from "../booking-email-history";
import { SchoolInvoiceListItem } from "../school-invoice-list-item";
import { BookingWithUsers } from "../booking-with-users";
import { SimpleSchool } from "../simple-school";
import { GroupBookingPost } from "../group-booking-post";
import { GroupBookingListItem } from "../group-booking-list-item";
import { GroupBookingWithDetail } from "../group-booking-with-detail";
import { BookingFinancialState } from "../booking-financial-state";
import { BookingPost } from "../booking-post";
import { SimpleBookingItem } from "../simple-booking-item";
import { VivawalletPaymentOrderPost } from "../vivawallet-payment-order-post";
import { VivawalletPaymentNotification } from "../vivawallet-payment-notification";
import { VivawalletPaymentOrderInfo } from "../vivawallet-payment-order-info";
import { BrazilianFinancialState } from "../brazilian-financial-state";
import { SalesReportResult } from "../stats/sales-report/sales-report-result";
import { SimpleSchoolBooking } from "../simple-school-booking";
import { BookingHighSchoolInfo } from "../booking-high-school-info";
import { BookingImmersionInfo } from "../booking-immersion-info";
import { MyBooking } from "../my-booking";
import { environment } from "src/environments/environment";
import { SimpleSchoolWithCountries } from "../simple-school-with-countries";
import { PaymentToSchoolListItem } from "../payment-to-school-list-item";
import { GmailMessageWithOption } from "../gmail-message-with-option";
import { EmailHistory } from "../email-history";
import { PaymentReminder } from "../payment-reminder";
import { PaymentReminderTemplate } from "../payment-reminder-template";
import { BookingEmailTemplateListItem } from "../booking-email-template-list-item";
import { PaymentReminderPost } from "../payment-reminder-post";
import { StudentReminderInfo } from "../student-reminder-info";
import { WeeklyBookingsData } from "../stats/sales-report/weekly-bookings-data";
import { AviInvoice } from "../avi-invoice";
import { AviInvoiceListItem } from "../avi-invoice-list-item";
import { BrugesFormPayload } from "../bruges-form-payload";
import { AgentBookingData } from "../agent-booking-data";
import { ConstantContactCampaignListItem } from "../constant-contact-campaign-list-item";
import { ConstantContactCampaignDetail } from "../constant-contact-campaign-detail";
import { BrevoContact } from "../brevo-contact";
import { BrevoListsContainer } from "../brevo-lists-container";
import { BookingIdListItem } from "../booking-id-list-item";
import { RefundRequestListItem } from "../refund-request-list-item";
import { AgentCommissionListItem } from "../agent-commission-list-item";
import { SchoolInvoiceToValidate } from "../school-invoice-to-validate";
import { CustomLink } from "../custom-link";
import { AgentCommissionPayment } from "../agent-commission-payment";
import { GeneralSupplier } from "../general-supplier";
import { GeneralSupplierInvoice } from "../general-supplier-invoice";
import { GeneralSupplierPaymentType } from "../general-supplier-payment-type";
import { GeneralSupplierUnpaidInvoice } from "../general-supplier-unpaid-invoice";
import { UserInfo } from "../security/user-info";
import { FinancialStateJsonContainer } from "../financial-state-json-container";

const httpOptions = {
    withCredentials: true
};

const stringHttpOptions = {
    headers: new HttpHeaders().set('Accept', 'text/plain'),
    responseType: 'text' as 'json'
};

@Injectable()
export class HttpService {

    private sbmsUrl = environment.sbmsUrl;
    private brugesFormUrl = environment.sbmsBrugesUrl;

    constructor(
        private http: HttpClient
    ) { }

    postStudent(student: Student): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/students", student, httpOptions);
    }

    getAllStudents(): Observable<Student[]> {
        return this.http.get<Student[]>(this.sbmsUrl + "/students", httpOptions);
    }

    postBooking(booking: Booking): Observable<Booking> {
        return this.http.post<Booking>(this.sbmsUrl + "/bookings", booking, httpOptions);
    }

    postSingleBooking(booking: BookingPost): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/booking-single", booking, httpOptions);
    }

    postBrugesBooking(booking: BasicBrugesVndBooking): Observable<BasicBrugesVndBooking> {
        return this.http.post<BasicBrugesVndBooking>(this.sbmsUrl + "/bookings-bruges", booking, httpOptions);
    }

    postEtcBooking(booking: EtcBooking): Observable<EtcBooking> {
        return this.http.post<EtcBooking>(this.sbmsUrl + "/bookings-etc", booking, httpOptions);
    }

    putBooking(booking: Booking): Observable<void> {
        console.log("put booking called");
        return this.http.put<void>(this.sbmsUrl + "/booking/update", booking, { withCredentials: true });
    }

    putBookingHighSchoolInformation(info: BookingHighSchoolInfo, bookingId: number): Observable<BookingHighSchoolInfo> {
        return this.http.put<BookingHighSchoolInfo>(this.sbmsUrl + "/booking-high-school-info/" + bookingId, info, httpOptions);
    }

    putBookingImmersionInformation(info: BookingImmersionInfo, bookingId: number): Observable<BookingImmersionInfo> {
        return this.http.put<BookingImmersionInfo>(this.sbmsUrl + "/booking-immersion-info/" + bookingId, info, httpOptions);
    }

    deleteBooking(bookingId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-delete/" + bookingId, httpOptions);
    }

    getAllBookings(): Observable<Booking[]> {
        return this.http.get<Booking[]>(this.sbmsUrl + "/bookings", httpOptions)
            .pipe(
                map(bookings => {
                    for (let booking of bookings) {
                        booking.startDate = moment(booking.startDate);
                        booking.endDate = moment(booking.endDate);
                        booking.duration = Math.ceil(booking.endDate.diff(booking.startDate, "weeks", true));
                    }
                    return bookings;
                })
            );
    }

    getAllSimpleBookings(): Observable<SimpleBooking[]> {
        return this.http.get<SimpleBooking[]>(this.sbmsUrl + "/simple-bookings", httpOptions);
    }

    getAllBookingsByPage(rows: number, offset: number): Observable<SimpleBooking[]> {
        return this.http.get<SimpleBooking[]>(this.sbmsUrl + "/bookings-all/" + rows + "/" + offset, httpOptions);
    }

    getAllBookingsNumber(): Observable<number> {
        return this.http.get<number>(this.sbmsUrl + "/bookings-all-record-number", httpOptions);
    }

    getBookingListItemsBySchoolId(schoolId: number): Observable<BookingListItem[]> {
        return this.http.get<BookingListItem[]>(this.sbmsUrl + "/booking-list-items/" + schoolId, httpOptions).pipe(map(bookings => {
            for (let booking of bookings) {
                booking.startDate = moment(booking.startDate);
                booking.endDate = moment(booking.endDate);
                booking.duration = Math.ceil(booking.endDate.diff(booking.startDate, "weeks", true));
                booking.labelId = booking.lvmsId == null ? booking.id : booking.lvmsId;
                booking.label = booking.labelId + ": " + booking.lastName + " " + booking.firstName;
            }
            return bookings.sort((a, b) => {
                return b.labelId - a.labelId;
            });
        }));
    }

    getAllEtcBookings(): Observable<Booking[]> {
        return this.http.get<Booking[]>(this.sbmsUrl + "/bookings-etc", httpOptions)
            .pipe(
                map(bookings => {
                    for (let booking of bookings) {
                        booking.startDate = moment(booking.startDate);
                        booking.endDate = moment(booking.endDate);
                    }
                    return bookings;
                })
            );
    }

    getBookingByUuid(uuid: string): Observable<Booking> {
        return this.http.get<Booking>(this.sbmsUrl + "/open/bookings/" + uuid, httpOptions)
            .pipe(map(booking => {
                booking.startDate = moment(booking.startDate);
                booking.endDate = moment(booking.endDate);
                booking.created = moment(booking.created);
                return booking;
            }
            ));
    }
    getBrugesVndBookingByUuid(uuid: string): Observable<SimpleBrugesVndBooking> {
        return this.http.get<SimpleBrugesVndBooking>(this.sbmsUrl + "/open/bruges-booking/" + uuid, httpOptions);
    }

    getStudentPictureByUuid(uuid: string): Observable<Blob> {
        return this.http.get<Blob>(this.sbmsUrl + "/open/student-picture/" + uuid, { responseType: "blob" as "json" });
    }

    postStudentPicture(file: FormData, uuid: string): Observable<void> {
        const httpOptions = {
            headers: new HttpHeaders()
        };
        return this.http.post<void>(this.sbmsUrl + "/open/student-picture/" + uuid, file, httpOptions);
    }

    putStudentPicture(file: FormData, uuid: string): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.put<Blob>(this.sbmsUrl + "/student-picture/" + uuid, file, httpOptions);
    }

    login(usernamePassword: UsernamePassword): Observable<HttpResponse<any>> {
        return this.http.post<HttpResponse<any>>(this.sbmsUrl + "/login", usernamePassword);
    }

    postSchoolDoc(schoolDoc: SchoolInfo): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/school", schoolDoc, httpOptions);
    }

    postMedicalDoc(medicalDoc: MedicalInfo): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/medical", medicalDoc, httpOptions);
    }

    postVademecum(vademecum: Vademecum): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/vademecum/" + vademecum.booking!.uuid, vademecum, httpOptions);
    }

    postVademecumV2(payload: BrugesFormPayload): Observable<void> {
        return this.http.post<void>(this.brugesFormUrl + "/webform/" + payload.uuid, payload, httpOptions);
    }

    getVademecumByBookingId(bookingId: number): Observable<Vademecum> {
        return this.http.get<Vademecum>(this.sbmsUrl + "/vademecums/" + bookingId, httpOptions);
    }

    getPdfBlob(bookingId: number, pdfLanguage: string): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/pdf/" + bookingId + "/" + pdfLanguage, httpOptions);
    }

    getRefundRequestPdf(requestId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/pdf/refund/" + requestId, httpOptions);
    }

    getSchoolDocumentFile(fileId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/school-document-file/" + fileId, httpOptions);
    }

    postSchoolDocumentFile(formData: FormData, schoolId: number) {
        const httpOptions = {
            headers: new HttpHeaders(),
            withCredentials: true
        };
        return this.http.post<void>(this.sbmsUrl + "/shool-document-file/" + schoolId, formData, httpOptions);
    }

    updateVademecum(vademecum: Vademecum): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/vademecum", vademecum, httpOptions);
    }

    getBookingsWithVademecumAndPicture(): Observable<BookingWithVademecum[]> {
        return this.http.get<BookingWithVademecum[]>(this.sbmsUrl + "/bookings-vademecum-picture", httpOptions)
            .pipe(map(bookings => {
                for (let booking of bookings) {
                    booking.startDate = moment(booking.startDate);
                    booking.endDate = moment(booking.endDate);
                }
                return bookings;
            }
            ));
    }

    getActiveBookingsWithVademecumAndPicture(): Observable<SimpleBrugesVndBooking[]> {
        return this.http.get<SimpleBrugesVndBooking[]>(this.sbmsUrl + "/active-bookings-vademecum-picture", httpOptions)
            .pipe(map(bookings => {
                for (let booking of bookings) {
                    booking.startDate = moment(booking.startDate);
                    booking.endDate = moment(booking.endDate);
                    booking.duration = Math.round(booking.endDate.diff(booking.startDate, "weeks", true));
                }
                return bookings;
            }
            ));
    }
    getActiveBookingsWithVademecumAndPictureByDates(startDate: string, endDate: string): Observable<SimpleBrugesVndBooking[]> {
        const params = new HttpParams()
            .append("startDate", startDate)
            .append("endDate", endDate);
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };

        return this.http.get<SimpleBrugesVndBooking[]>(this.sbmsUrl + "/active-bookings-vademecum-picture", httpOptions)
            .pipe(map(bookings => {
                for (let booking of bookings) {
                    booking.startDate = moment(booking.startDate);
                    booking.endDate = moment(booking.endDate);
                    booking.duration = Math.round(booking.endDate.diff(booking.startDate, "weeks", true));
                }
                return bookings;
            }
            ));
    }

    getCurrentBookingsWithVademecum(): Observable<SimpleBrugesVndBooking[]> {
        return this.http.get<SimpleBrugesVndBooking[]>(this.sbmsUrl + "/bookings-current/bruges-vnd", { withCredentials: true }).pipe(map(bookings => {
            for (let booking of bookings) {
                booking.startDate = moment(booking.startDate);
                booking.endDate = moment(booking.endDate);
                booking.duration = Math.round(booking.endDate.diff(booking.startDate, "weeks", true));
            }
            return bookings;
        }
        ));
    }

    getInactiveBookingsWithVademecumAndPicture(): Observable<SimpleBrugesVndBooking[]> {
        return this.http.get<SimpleBrugesVndBooking[]>(this.sbmsUrl + "/inactive-bookings-vademecum-picture", httpOptions)
            .pipe(map(bookings => {
                for (let booking of bookings) {
                    booking.startDate = moment(booking.startDate);
                    booking.endDate = moment(booking.endDate);
                    booking.duration = Math.round(booking.endDate.diff(booking.startDate, "weeks", true));
                }
                return bookings;
            }
            ));
    }

    hasVademecum(bookingId: number): Observable<boolean> {
        return this.http.get<boolean>(this.sbmsUrl + "/has-vademecum/" + bookingId, httpOptions);
    }

    getRoleByName(name: number): Observable<Role> {
        return this.http.get<Role>(this.sbmsUrl + "roles/" + name, httpOptions);
    }

    getEmailTemplates(): Observable<EmailTemplate[]> {
        return this.http.get<EmailTemplate[]>(this.sbmsUrl + "/email-templates", httpOptions);
    }

    getEmailTemplatesByLanguage(language: Language): Observable<EmailTemplate[]> {
        return this.http.get<EmailTemplate[]>(this.sbmsUrl + "/email-templates/" + language.id, httpOptions);
    }

    postEmailTemplate(template: EmailTemplate): Observable<EmailTemplate> {
        return this.http.post<EmailTemplate>(this.sbmsUrl + "/email-template", template, httpOptions);
    }

    putEmailTemplate(template: EmailTemplate): Observable<EmailTemplate> {
        return this.http.put<EmailTemplate>(this.sbmsUrl + "/email-template", template, httpOptions);
    }

    postTemplateLinks(links: TemplateLink[]): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/template-links", links, httpOptions);
    }
    deleteEmailTemplate(template: EmailTemplate): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/email-template/" + template.id, httpOptions);
    }

    getSchools(): Observable<SchoolListItem[]> {
        return this.http.get<SchoolListItem[]>(this.sbmsUrl + "/schools", httpOptions);
    }

    getActiveSchools(): Observable<SchoolListItem[]> {
        return this.http.get<SchoolListItem[]>(this.sbmsUrl + "/schools-active", httpOptions);
    }
    getSimpleSchools(): Observable<SimpleSchool[]> {
        return this.http.get<SimpleSchool[]>(this.sbmsUrl + "/schools-simple", httpOptions);
    }
    getSchoolsWithCountries(): Observable<SimpleSchoolWithCountries[]> {
        return this.http.get<SimpleSchoolWithCountries[]>(this.sbmsUrl + "/schools-with-countries", httpOptions);
    }

    getOnlineSchools(): Observable<School[]> {
        return this.http.get<School[]>(this.sbmsUrl + "/schools-online", httpOptions);
    }

    postSchool(school: School): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/schools", school, httpOptions);
    }
    getSchoolById(id: number): Observable<SchoolWithDetail> {
        return this.http.get<SchoolWithDetail>(this.sbmsUrl + "/school/" + id, httpOptions);
    }
    deleteSchoolById(id: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/school/" + id, httpOptions);
    }
    restoreSchoolById(id: number): Observable<void> {
        return this.http.patch<void>(this.sbmsUrl + "/school-restore/" + id, null, httpOptions);
    }

    putSchool(school: SchoolWithDetail): Observable<SchoolWithDetail> {
        return this.http.put<SchoolWithDetail>(this.sbmsUrl + "/schools", school, httpOptions);
    }

    getCsvFile(uuid: string): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/open/csv/" + uuid, httpOptions);
    }

    putCsvFile(file: FormData, uuid: string): Observable<void> {
        const httpOptions = {
            headers: new HttpHeaders(),
            withCredentials: true
        };
        return this.http.put<void>(this.sbmsUrl + "/update-csv/" + uuid, file, httpOptions);
    }

    getAllGuides(): Observable<Guide[]> {
        return this.http.get<Guide[]>(this.sbmsUrl + "/guides", httpOptions);
    }

    postGuide(guide: Guide): Observable<Guide> {
        return this.http.post<Guide>(this.sbmsUrl + "/guides", guide, httpOptions);
    }

    putGuide(guide: Guide): Observable<Guide> {
        return this.http.put<Guide>(this.sbmsUrl + "/guides", guide, httpOptions);
    }

    getGuideById(id: number): Observable<Guide> {
        return this.http.get<Guide>(this.sbmsUrl + "/guide/" + id, httpOptions);
    }

    deleteGuideById(id: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/guide-delete/" + id, httpOptions);
    }

    getCallSummaries(): Observable<CallSummary[]> {
        return this.http.get<CallSummary[]>(this.sbmsUrl + "/call-summaries", httpOptions);
    }

    postCallSummary(summary: CallSummary): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/call-summary", summary, httpOptions);
    }

    getCallSummaryById(id: number): Observable<CallSummary> {
        return this.http.get<CallSummary>(this.sbmsUrl + "/call-summary/" + id, httpOptions).pipe(map(summary => {
            if (summary.dateToContact) {
                summary.dateToContact = moment(summary.dateToContact);
            }
            if (summary.lastContacted) {
                summary.lastContacted = moment(summary.lastContacted);
            }
            return summary;
        }));
    }

    putCallSummary(summary: CallSummary): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/call-summary", summary, httpOptions);
    }

    getAllInterestLevels(): Observable<InterestLevel[]> {
        return this.http.get<InterestLevel[]>(this.sbmsUrl + "/interest-levels", httpOptions);
    }

    getEtcPdf(): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/pdf/etc", httpOptions);
    }

    getPromotions(): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.sbmsUrl + "/promotions", httpOptions)
            .pipe(map(promotions => {
                for (let promotion of promotions) {
                    promotion.start = moment(promotion.start).utc(true);
                    promotion.end = moment(promotion.end).utc(true);
                }
                return promotions;
            }));
    }

    getCurrentPromotions(): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.sbmsUrl + "/promotions-current", httpOptions)
            .pipe(map(promotions => {
                for (let promotion of promotions) {
                    promotion.start = moment(promotion.start).utc(true);
                    promotion.end = moment(promotion.end).utc(true);
                }
                return promotions;
            }));
    }

    postPromotion(promotion: Promotion): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/promotion", promotion, httpOptions);
    }

    getStudyPrograms(): Observable<StudyProgram[]> {
        return this.http.get<StudyProgram[]>(this.sbmsUrl + "/study-programs", httpOptions);
    }

    postStudyProgram(program: StudyProgram): Observable<StudyProgram> {
        return this.http.post<StudyProgram>(this.sbmsUrl + "/study-program", program, httpOptions);
    }

    getPromotionById(id: number): Observable<Promotion> {
        return this.http.get<Promotion>(this.sbmsUrl + "/promotion/" + id, httpOptions)
            .pipe(map(promotion => {
                promotion.start = moment(promotion.start).utc(true);
                promotion.end = moment(promotion.end).utc(true);
                return promotion;
            }));
    }

    updatePromotion(promotion: Promotion): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/promotion", promotion, httpOptions);
    }

    getEtcParentalPermissionById(id: number): Observable<EtcParentalPermission> {
        return this.http.get<EtcParentalPermission>(this.sbmsUrl + "/parental-permission/" + id, httpOptions);
    }

    getGenders(): Observable<Gender[]> {
        return this.http.get<Gender[]>(this.sbmsUrl + "/open/genders");
    }

    getNationalities(): Observable<Nationality[]> {
        return this.http.get<Nationality[]>(this.sbmsUrl + "/open/nationalities");
    }

    postEtcParentalPermission(permission: EtcParentalPermission): Observable<EtcParentalPermission> {
        return this.http.post<EtcParentalPermission>(this.sbmsUrl + "/parental-permission", permission, httpOptions);
    }

    getAllEtcStudentParentLanguages(): Observable<EtcStudentParentLanguage[]> {
        return this.http.get<EtcStudentParentLanguage[]>(this.sbmsUrl + "/open/etc-languages");
    }

    getCounsellors(): Observable<UserForBackend[]> {
        return this.http.get<UserForBackend[]>(this.sbmsUrl + "/system-users/counsellor", httpOptions);
    }

    getAllKanbanLists(): Observable<KanbanList[]> {
        return this.http.get<KanbanList[]>(this.sbmsUrl + "/kanban-lists", httpOptions);
    }

    getAllLinkItems(): Observable<LinkItem[]> {
        return this.http.get<LinkItem[]>(this.sbmsUrl + "/open/external-links")
            .pipe(map(links => {
                for (let link of links) {
                    if (link.icon) {
                        link.faviconUrl = "data:image/png;base64," + link.icon;
                    }
                }
                return links;
            }));
    }

    postLinkItem(link: LinkItem): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/external-links", link, httpOptions);
    }

    deleteLinkItem(link: LinkItem): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/external-links/" + link.id, httpOptions);
    }

    sendEmailByGoogle(email: GmailMessage): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/oauth2-gmail", email, httpOptions);
    }

    sendHtmlEmailByGoogleWithQuotations(formData: FormData): Observable<void> {
        let params = new HttpParams().set("withPastePixel", false);
        const httpOptions = {
            headers: new HttpHeaders(),
            params: params,
            withCredentials: true
        };
        return this.http.post<void>(this.sbmsUrl + "/oauth2-gmail-html-quotations", formData, httpOptions);
    }

    sendHtmlEmailByGoogole(message: GmailMessageWithBookingFiles, withPastePixel: boolean): Observable<HttpResponse<string>> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.post<HttpResponse<string>>(this.sbmsUrl + "/oauth2-gmail-html/" + withPastePixel, message, httpOptions);
    }

    testHtmlEmailByGoogle(message: GmailMessage): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/oauth2-gmail-html-raw", message, httpOptions);
    }

    sendHtmlEmailWithContactRequestQuotations(formData: FormData, contactRequestId: number, signatureId: number, withPastePixel: boolean): Observable<void> {
        let params: HttpParams | null = null;
        if (signatureId) {
            params = new HttpParams().set("signatureId", signatureId.toString())
                .set("withPastePixel", withPastePixel);
        } else {
            params = new HttpParams().set("withPastePixel", withPastePixel);
        }
        const httpOptions = {
            headers: new HttpHeaders(),
            params: params!,
            withCredentials: true
        };
        return this.http.post<void>(this.sbmsUrl + "/oauth2-gmail-html-quotation/" + contactRequestId, formData, httpOptions);
    }

    sendWpContactRequestResponseByGoogle(email: GmailMessage, requestId: number) {
        return this.http.post<void>(this.sbmsUrl + "/wp-contact-request-response/" + requestId, email, httpOptions);
    }

    postSchoolComment(comment: SchoolComment, schoolId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/school-comment/" + schoolId, comment, httpOptions);
    }
    getSchoolCommentsBySchoolId(schoolId: number): Observable<SchoolComment[]> {
        return this.http.get<SchoolComment[]>(this.sbmsUrl + "/school-comment/" + schoolId, httpOptions);
    }
    deleteSchoolComment(commentId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/school-comment/" + commentId, httpOptions);
    }
    putSchoolComment(comment: SchoolComment): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/school-comment", comment, httpOptions);
    }
    getLastUpdateHistory(rowNum: number): Observable<AuditUpdate[]> {
        return this.http.get<AuditUpdate[]>(this.sbmsUrl + "/last-audit-update/" + rowNum, httpOptions);
    }
    getCallSummaryCommentsBySummaryId(summaryId: number): Observable<CallSummaryComment[]> {
        return this.http.get<CallSummaryComment[]>(this.sbmsUrl + "/call-summary-comment/" + summaryId, httpOptions);
    }
    getCallSummaryComments(): Observable<CallSummaryComment[]> {
        return this.http.get<CallSummaryComment[]>(this.sbmsUrl + "/call-summary-comment-all", httpOptions);
    }
    updateCallSummaryComment(summary: CallSummaryComment): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/call-summary-comment", summary, httpOptions);
    }
    deleteCallSummaryComment(summaryId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/call-summary-comment/" + summaryId, httpOptions);
    }
    postCallSummaryComment(summary: CallSummaryComment): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/call-summary-comment", summary, httpOptions);
    }

    postTranslations(item: WpTranslationItem[]): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/wp-translations", item, httpOptions);
    }

    getTranslations(): Observable<WpTranslationItem[]> {
        return this.http.get<WpTranslationItem[]>(this.sbmsUrl + "/wp-translations", httpOptions);
    }
    updateTranslation(item: WpTranslationItem): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/wp-translation", item, httpOptions);
    }
    updateTranslations(items: WpTranslationItem[]): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/wp-translation-list", items, httpOptions);
    }
    deleteTranslation(id: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/wp-translations/" + id, httpOptions);
    }

    postTestFile(content: FormData): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/test-file-upload", content, httpOptions);
    }
    getActiveUsers(): Observable<UserForBackend[]> {
        return this.http.get<UserForBackend[]>(this.sbmsUrl + "/users", httpOptions);
    }
    postSystemUser(user: UserForBackend): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/system-users", user, httpOptions);
    }
    getSystemUserById(id: number): Observable<UserForBackend> {
        return this.http.get<UserForBackend>(this.sbmsUrl + "/system-user/" + id, httpOptions);
    }
    putSystemUser(user: UserForBackend): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/users", user, httpOptions);
    }

    getCurrencies(): Observable<Currency[]> {
        return this.http.get<Currency[]>(this.sbmsUrl + "/currencies", httpOptions);
    }
    postRefundRequest(request: RefundRequest): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/refund-request", request, httpOptions);
    }

    getRefundRequests(): Observable<RefundRequestListItem[]> {
        return this.http.get<RefundRequestListItem[]>(this.sbmsUrl + "/refund-requests", httpOptions);
    }
    getRefundRequestById(id: number): Observable<RefundRequest> {
        return this.http.get<RefundRequest>(this.sbmsUrl + "/refund-request/" + id, httpOptions);
    }
    updateRefundRequest(request: RefundRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/refund-request", request, httpOptions);
    }

    postPdfDocumentTemplate(template: BookingReportTemplate): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/pdf-template", template, httpOptions);
    }

    getPdfDocumentTemplates(): Observable<BookingReportTemplate[]> {
        return this.http.get<BookingReportTemplate[]>(this.sbmsUrl + "/pdf-templates", httpOptions);
    }

    getPdfDocumentTemplateById(id: number): Observable<BookingReportTemplate> {
        return this.http.get<BookingReportTemplate>(this.sbmsUrl + "/pdf-template/" + id, httpOptions);
    }

    getPdfDocumentTemplatesByLanguageId(languageId: number): Observable<BookingReportTemplate[]> {
        return this.http.get<BookingReportTemplate[]>(this.sbmsUrl + "/pdf-templates/" + languageId, httpOptions);
    }
    // This will get non-hidden templates by student languages and school language
    getBookingPdfDocumentTemplatesByLanguageId(studentLanguageId: number): Observable<BookingReportTemplate[]> {
        return this.http.get<BookingReportTemplate[]>(this.sbmsUrl + "/pdf-booking-templates/" + studentLanguageId, httpOptions);
    }

    getBookingConfirmationTemplatesByLanguageId(languageId: number): Observable<BookingConfirmationTemplate[]> {
        return this.http.get<BookingConfirmationTemplate[]>(this.sbmsUrl + "/booking-confirmation-templates/" + languageId, httpOptions);
    }

    getBookingConfirmationTemplateById(id: number): Observable<BookingConfirmationTemplateWithDetail> {
        return this.http.get<BookingConfirmationTemplateWithDetail>(this.sbmsUrl + "/booking-confirmation-template/" + id, httpOptions);
    }

    updateBookingConfirmationTemplate(template: BookingConfirmationTemplateWithDetail): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-confirmation-template", template, httpOptions);
    }
    getBookingFinalConfirmationTemplatesByLanguageId(languageId: number): Observable<BookingFinalConfirmationTemplate[]> {
        return this.http.get<BookingFinalConfirmationTemplate[]>(this.sbmsUrl + "/booking-final-confirmation-templates/" + languageId, httpOptions);
    }
    getBookingFinalConfirmationTemplateById(id: number): Observable<BookingFinalConfirmationTemplateWithDetail> {
        return this.http.get<BookingFinalConfirmationTemplateWithDetail>(this.sbmsUrl + "/booking-final-confirmation-template/" + id, httpOptions);
    }

    updateBookingFinalConfirmationTemplate(template: BookingFinalConfirmationTemplateWithDetail): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-final-confirmation-template", template, httpOptions);
    }

    getPdfByTemplateId(id: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/pdf-template-generate/" + id, httpOptions);
    }

    getBookingPdfById(templateId: number, bookingId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-pdf-template/" + templateId + "/" + bookingId, httpOptions);
    }

    updatePdfTemplate(template: BookingReportTemplate): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/pdf-template", template, httpOptions);
    }

    getWpBookingRequests(): Observable<WpBookingRequest[]> {
        return this.http.get<WpBookingRequest[]>(this.sbmsUrl + "/wp-booking-requests", httpOptions).pipe(map(
            requests => {
                for (let request of requests) {
                    request.startDay = moment(request.startDay);
                    request.endDay = moment(request.endDay);
                    request.created = moment(request.created);
                    request.duration = Math.round(request.endDay.diff(request.startDay, "days") / 7);
                }
                return requests;
            }
        ));
    }

    getNewWpBookingRequests(): Observable<WpBookingRequest[]> {
        return this.http.get<WpBookingRequest[]>(this.sbmsUrl + "/wp-booking-requests-new", httpOptions).pipe(map(
            requests => {
                for (let request of requests) {
                    request.startDay = moment(request.startDay);
                    request.endDay = moment(request.endDay);
                    request.created = moment(request.created);
                    request.duration = Math.round(request.endDay.diff(request.startDay, "days") / 7);
                }
                return requests;
            }
        ));
    }

    getApprovedWpBookingRequests(): Observable<WpBookingRequest[]> {
        return this.http.get<WpBookingRequest[]>(this.sbmsUrl + "/wp-booking-requests-approved", httpOptions).pipe(map(
            requests => {
                for (let request of requests) {
                    request.startDay = moment(request.startDay);
                    request.endDay = moment(request.endDay);
                    request.created = moment(request.created);
                    request.duration = Math.round(request.endDay.diff(request.startDay, "days") / 7);
                }
                return requests;
            }
        ));
    }

    getDeletedWpBookingRequests(): Observable<WpBookingRequest[]> {
        return this.http.get<WpBookingRequest[]>(this.sbmsUrl + "/wp-booking-requests-deleted", httpOptions).pipe(map(
            requests => {
                for (let request of requests) {
                    request.startDay = moment(request.startDay);
                    request.endDay = moment(request.endDay);
                    request.created = moment(request.created);
                    request.duration = Math.round(request.endDay.diff(request.startDay, "days") / 7);
                }
                return requests;
            }
        ));
    }

    getWpBookingRequestById(id: number): Observable<WpBookingRequest> {
        return this.http.get<WpBookingRequest>(this.sbmsUrl + "/wp-booking-request/" + id, httpOptions);
    }

    getAllCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(this.sbmsUrl + "/countries", httpOptions);
    }

    getCountriesBySchoolId(schoolId: number): Observable<Country[]> {
        return this.http.get<Country[]>(this.sbmsUrl + "/countries/" + schoolId, httpOptions);
    }

    getWpContactRequests(): Observable<WpContactRequest[]> {
        return this.http.get<WpContactRequest[]>(this.sbmsUrl + "/wp-contact-requests", httpOptions);
    }

    getWpContactRequestById(requestId: number): Observable<WpContactRequest> {
        return this.http.get<WpContactRequest>(this.sbmsUrl + "/wp-contact-request/" + requestId, httpOptions);
    }

    postWpContactRequestComment(request: WpContactRequestComment): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/wp-contact-request-comment", request, httpOptions);
    }

    getWpContactRequestComments(requestId: number): Observable<WpContactRequestComment[]> {
        return this.http.get<WpContactRequestComment[]>(this.sbmsUrl + "/wp-contact-request-comments/" + requestId, httpOptions);
    }

    getUserInfoByCookie(): Observable<UserForBackend> {
        return this.http.get<UserForBackend>(this.sbmsUrl + "/system-user-by-cookie", httpOptions);
    }

    // getSystemUserByName(name: string): Observable<UserForBackend> {
    //     console.log(name);
    //     return this.http.get<UserForBackend>(this.sbmsUrl + "/system-user?userName=" + name);
    // }

    checkGmailRefreshToken(): Observable<boolean> {
        return this.http.get<boolean>(this.sbmsUrl + "/system-user/check-gmail-token", httpOptions);
    }

    getConstantContactLists(): Observable<ConstantContactListList> {
        return this.http.get<ConstantContactListList>(this.sbmsUrl + "/constant-contact-lists", httpOptions);
    }

    postConstantContactContact(contact: ConstantContactContactPostRequest): Observable<any> {
        return this.http.post<any>(this.sbmsUrl + "/constant-contact", contact, httpOptions);
    }

    postConstantContactContactWithStudent(contact: ConstantContactContactPostRequest, studentId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/constant-contact-student/" + studentId, contact, httpOptions);
    }

    putConstantContactContact(contact: ConstantContactContactPutRequest, contactId: string): Observable<ConstantContactContact> {
        return this.http.put<ConstantContactContact>(this.sbmsUrl + "/constant-contact-contact-update/" + contactId, contact, httpOptions);
    }
    postConstantContactContactTest(contact: ConstantContactContact): Observable<ConstantContactContact> {
        return this.http.post<ConstantContactContact>(this.sbmsUrl + "/constant-contact-test", contact, httpOptions);
    }

    getWpContactRequestResponseByRequestId(requestId: number): Observable<WpContactRequestResponse> {
        return this.http.get<WpContactRequestResponse>(this.sbmsUrl + "/wp-contact-request-response/" + requestId, httpOptions);
    }

    deleteWpContactRequestById(requestId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/wp-contact-request/" + requestId, httpOptions);
    }

    getWpContactRequestNew(): Observable<WpContactRequest[]> {
        return this.http.get<WpContactRequest[]>(this.sbmsUrl + "/wp-contact-requests/not-processed", httpOptions);
    }

    getWpContactRequestProcessed(): Observable<WpContactRequest[]> {
        return this.http.get<WpContactRequest[]>(this.sbmsUrl + "/wp-contact-requests/processed", httpOptions);
    }

    getWpContactRequestDeleted(): Observable<WpContactRequest[]> {
        return this.http.get<WpContactRequest[]>(this.sbmsUrl + "/wp-contact-requests/deleted", httpOptions);
    }

    testConstantContactContactPost(contact: ConstantContactContactJson): Observable<ConstantContactContactJson> {
        return this.http.post<ConstantContactContactJson>(this.sbmsUrl + "/constant-contact-test", contact, httpOptions);
    }

    updateWpContactRequest(request: WpContactRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/wp-contact-request", request, httpOptions);
    }

    updateWpContactRequestWithUsers(request: WpContactRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/wp-contact-request-users", request, httpOptions);
    }

    getSalesAgents(): Observable<SalesAgent[]> {
        return this.http.get<SalesAgent[]>(this.sbmsUrl + "/sales-agents", httpOptions);
    }

    restoreWpContactRequest(requestId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/contact-request/restore/" + requestId, null);
    }

    getBrugesAndVnd(): Observable<School[]> {
        return this.http.get<School[]>(this.sbmsUrl + "/schools-bruges-vnd", httpOptions);
    }

    postBookingPreConfirmation(confirmation: BookingPreConfirmation, bookingId: number): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/confirmation/" + bookingId, confirmation, httpOptions);
    }

    getSalesProductTypes(): Observable<SalesProductType[]> {
        return this.http.get<SalesProductType[]>(this.sbmsUrl + "/sales-product-types", httpOptions);
    }

    putBookingConfirmation(confirmation: BookingPreConfirmation): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/confirmation", confirmation, httpOptions);
    }

    getBookingById(id: number): Observable<Booking> {
        return this.http.get<Booking>(this.sbmsUrl + "/booking/" + id, httpOptions)
            .pipe(
                map(booking => {
                    if (booking.preConfirmation) {
                        for (let product of booking.preConfirmation.productList) {
                            product.amount = new Decimal(product.amount);
                        }
                    }
                    booking.startDate = moment(booking.startDate);
                    booking.endDate = moment(booking.endDate);
                    booking.sentToSchool = booking.sentToSchool == null ? null : moment(booking.sentToSchool);
                    booking.schoolConfirmed = booking.schoolConfirmed == null ? null : moment(booking.schoolConfirmed);
                    booking.preConfirmationSent = booking.preConfirmationSent == null ? null : moment(booking.preConfirmationSent);
                    booking.insuranceSent = booking.insuranceSent == null ? null : moment(booking.insuranceSent);
                    booking.excursionDate = booking.excursionDate == null ? null : moment(booking.excursionDate);
                    booking.created = booking.created == null ? null : moment(booking.created);
                    booking.completePaymentReceived = booking.completePaymentReceived == null ? null : moment(booking.completePaymentReceived);
                    booking.depositReceived = booking.depositReceived == null ? null : moment(booking.depositReceived);
                    booking.finalConfirmationSent = booking.finalConfirmationSent == null ? null : moment(booking.finalConfirmationSent);
                    booking.lastModified = moment(booking.lastModified);
                    if (booking.student) {
                        let student = booking.student;
                        student.birthDay = student.birthDay == null ? null : moment(student.birthDay);
                    }
                    return booking;
                })
            );
    }

    postPaymentReceived(payments: PaymentReceived, bookingId: number): Observable<PaymentReceived> {
        return this.http.post<PaymentReceived>(this.sbmsUrl + "/payment-received/" + bookingId, payments, httpOptions);
    }

    getPaymentsReceivedByBooking(bookingId: number): Observable<PaymentReceived[]> {
        return this.http.get<PaymentReceived[]>(this.sbmsUrl + "/payments-received/" + bookingId, httpOptions);
    }

    getAllPaymentTypes(): Observable<PaymentType[]> {
        return this.http.get<PaymentType[]>(this.sbmsUrl + "/payment-types", httpOptions);
    }

    postSchoolInvoices(invoices: SchoolInvoicePost[]): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/school-invoice/", invoices, httpOptions);
    }

    postNewSchoolInvoice(invoice: SchoolInvoicePost, invoiceFile: File, bookingId: number): Observable<SchoolInvoice> {
        const formData: FormData = new FormData();
        formData.append('file', invoiceFile, invoiceFile.name);
        formData.append('json', JSON.stringify(invoice));
        return this.http.post<SchoolInvoice>(this.sbmsUrl + "/school-invoice-new/" + bookingId, formData, {
            headers: new HttpHeaders(),
            withCredentials: true
        });
    }

    putSchoolInvoiceWithPaymentOrders(invoice: SchoolInvoiceWithPaymentOrders, file: File | null): Observable<void> {
        const formData: FormData = new FormData();
        formData.append('json', JSON.stringify(invoice));
        if (file) {
            formData.append('file', file, file.name);
        }
        return this.http.put<void>(this.sbmsUrl + "/school-invoice-payment-orders", formData, {
            headers: new HttpHeaders(),
            withCredentials: true
        });
    }

    //used to update school invoice that should be paid by one payment
    putSchoolInvoiceWithOnePaymentOrder(invoice: SchoolInvoiceWithPaymentOrders, file: File | null): Observable<void> {
        const formData: FormData = new FormData();
        formData.append('json', JSON.stringify(invoice));
        if (file) {
            formData.append('file', file, file.name);
        }
        return this.http.put<void>(this.sbmsUrl + "/school-invoice-payment-order", formData, {
            headers: new HttpHeaders(),
            withCredentials: true
        });
    }

    postSchoolInvoiceWithPaymentOrders(invoice: SchoolInvoiceWithPaymentOrders, file: File, bookingId: number): Observable<void> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify(invoice));
        return this.http.post<void>(this.sbmsUrl + "/school-invoice-payment-orders/" + bookingId, formData, {
            headers: new HttpHeaders(),
            withCredentials: true
        });
    }

    getSchoolInvoicesWithPaymentOrdersByBookingId(bookingId: number): Observable<SchoolInvoiceWithPaymentOrders[]> {
        return this.http.get<SchoolInvoiceWithPaymentOrders[]>(this.sbmsUrl + "/school-invoices-payment-order/" + bookingId, httpOptions).pipe(map(invoices => {
            for (let invoice of invoices) {
                invoice.date = moment(invoice.date);
                invoice.created == null ? null : invoice.created = moment(invoice.created);
            }
            return invoices;
        }))
    }

    getSchoolInvoiceWithPaymentOrdersByInvoiceId(invoiceId: number): Observable<SchoolInvoiceWithPaymentOrders> {
        return this.http.get<SchoolInvoiceWithPaymentOrders>(this.sbmsUrl + "/school-invoice-with-payment-orders/" + invoiceId, httpOptions);
    }

    putPaymentReceived(payment: PaymentReceived, isFinancialRecord: boolean, bookingId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/payment-received/" + isFinancialRecord + "/" + bookingId, payment, httpOptions);
    }

    deletePaymentReceived(paymentId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/payment-received/" + paymentId, httpOptions);
    }

    putSchoolInvoices(invoices: SchoolInvoice[], bookingId: number): Observable<SchoolInvoice[]> {
        return this.http.put<SchoolInvoice[]>(this.sbmsUrl + "/school-invoices/" + bookingId, invoices, httpOptions)
            .pipe(map(invoices => {
                for (let invoice of invoices) {
                    invoice.amount = new Decimal(invoice.amount);
                    invoice.amountInEuro = new Decimal(invoice.amountInEuro!);
                }
                return invoices;
            }));
    }

    deleteSchoolInvoice(invoiceId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/school-invoice/" + invoiceId, httpOptions);
    }

    putPaymentsToSupplier(payments: PaymentToSupplier[], bookingId: number): Observable<PaymentToSupplier[]> {
        return this.http.put<PaymentToSupplier[]>(this.sbmsUrl + "/payments-supplier/" + bookingId, payments, httpOptions);
    }

    deletepaymentToSupplier(paymentId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/payment-supplier/" + paymentId, httpOptions);
    }

    getExchangeRate(currency: Currency, date: moment.Moment, withBuffer?: boolean): Observable<ExchangeRate> {
        let params = new HttpParams().set("date", date.format("YYYY-MM-DD"));
        if (withBuffer == null || withBuffer == undefined) {
            withBuffer = false;
        }
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };
        return this.http.get<ExchangeRate>(this.sbmsUrl + "/exchange-rate/" + currency.id + "/" + withBuffer, httpOptions).pipe(map(rate => {
            rate.exchangeRate = new Decimal(rate.exchangeRate.toString());
            return rate;
        }));
    }
    getExchangeRateToEuro(currency: Currency, date: moment.Moment, confirmationBaseCurrency: Currency, withBuffer?: boolean): Observable<ExchangeRate> {
        let params = new HttpParams().set("date", date.format("YYYY-MM-DD"));
        if (withBuffer == null || withBuffer == undefined) {
            withBuffer = false;
        }
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };
        return this.http.get<ExchangeRate>(this.sbmsUrl + "/exchange-rate-to-euro/" + currency.id + "/" + confirmationBaseCurrency.id + "/" + withBuffer, httpOptions).pipe(map(rate => {
            rate.exchangeRate = new Decimal(rate.exchangeRate.toString());
            return rate;
        }));
    }

    getExchangeRateWithBaseCurrency(baseCurrency: Currency, targetCurrency: Currency, date: moment.Moment, confirmationBaseCurrency: Currency, withBuffer?: boolean): Observable<ExchangeRate> {
        let params = new HttpParams().set("date", date.format("YYYY-MM-DD"));
        if (withBuffer == null || withBuffer == undefined) {
            withBuffer = false;
        }
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };
        return this.http.get<ExchangeRate>(this.sbmsUrl + "/exchange-rate-get/" + baseCurrency.id + "/" + targetCurrency.id + "/" + confirmationBaseCurrency.id + "/" + withBuffer, httpOptions).pipe(map(rate => {
            rate.exchangeRate = new Decimal(rate.exchangeRate.toString());
            return rate;
        }));
    }

    getRegions(): Observable<Region[]> {
        return this.http.get<Region[]>(this.sbmsUrl + "/regions", httpOptions);
    }

    postInternalBookingComment(comment: InternalBookingComment, bookingId: number): Observable<InternalBookingComment> {
        return this.http.post<InternalBookingComment>(this.sbmsUrl + "/internal-booking-comment/" + bookingId, comment, httpOptions);
    }

    updateInternalBookingComment(comment: InternalBookingComment): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/internal-booking-comment", comment, httpOptions);
    }

    deleteInternalBookingComment(commentId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/internal-booking-comment/" + commentId, httpOptions);
    }

    getTargetLanguageLevels(): Observable<TargetLanguageLevel[]> {
        return this.http.get<TargetLanguageLevel[]>(this.sbmsUrl + "/target-language-levels", httpOptions);
    }

    getAccommodationTypes(): Observable<AccommodationType[]> {
        return this.http.get<AccommodationType[]>(this.sbmsUrl + "/accommodation-types", httpOptions);
    }
    getRoomTypes(): Observable<RoomType[]> {
        return this.http.get<RoomType[]>(this.sbmsUrl + "/room-types", httpOptions);
    }
    getBoardTypes(): Observable<BoardType[]> {
        return this.http.get<BoardType[]>(this.sbmsUrl + "/board-types", httpOptions);
    }
    getTravelTypes(): Observable<TravelType[]> {
        return this.http.get<TravelType[]>(this.sbmsUrl + "/travel-types", httpOptions).pipe(map(
            types => {
                for (let type of types) {
                    type.longName = type.code + " " + type.description;
                }
                return types;
            }
        ));
    }
    postTravelType(travel: TravelType): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/travel-type", travel, httpOptions);
    }
    getTransportTypes(): Observable<TransportType[]> {
        return this.http.get<TransportType[]>(this.sbmsUrl + "/transport-types", httpOptions);
    }
    getTravelType(id: number): Observable<TravelType> {
        return this.http.get<TravelType>(this.sbmsUrl + "/travel-type/" + id, httpOptions);
    }
    putTravelType(travelType: TravelType): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/travel-type", travelType, httpOptions);
    }
    getTransferTypes(): Observable<TransferType[]> {
        return this.http.get<TransferType[]>(this.sbmsUrl + "/transfer-types", httpOptions);
    }

    getLanguages(): Observable<Language[]> {
        return this.http.get<Language[]>(this.sbmsUrl + "/language-list", httpOptions);
    }

    putWpBookingRequest(request: WpBookingRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/wp-booking-request", request, httpOptions);
    }

    deleteWpBookingRequest(requestId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/wp-booking-request/" + requestId, httpOptions);
    }

    getStudentById(studentId: number): Observable<Student> {
        return this.http.get<Student>(this.sbmsUrl + "/student/" + studentId, httpOptions);
    }

    approveWpBookingRequest(request: BookingRequestToApprove): Observable<Booking> {
        return this.http.post<Booking>(this.sbmsUrl + "/wp-booking-approve", request, httpOptions);
    }

    putStudent(student: Student): Observable<number> {
        return this.http.put<number>(this.sbmsUrl + "/student-detail", student, httpOptions);
    }
    postStudentComment(comment: StudentComment, studentId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/student-comment/" + studentId, comment, httpOptions);
    }
    getStudentComments(studentId: number): Observable<StudentComment[]> {
        return this.http.get<StudentComment[]>(this.sbmsUrl + "/student-comments/" + studentId, httpOptions);
    }

    getLanguageCoursesBySchoolId(schoolId: number): Observable<LanguageCourse[]> {
        return this.http.get<LanguageCourse[]>(this.sbmsUrl + "/language-courses/" + schoolId, httpOptions);
    }
    deleteLanguageCourseById(courseId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/language-course/" + courseId, httpOptions);
    }
    getSearchOperators(): Observable<SearchOperator[]> {
        return this.http.get<SearchOperator[]>(this.sbmsUrl + "/search-operators", httpOptions);
    }
    getSearchActions(): Observable<SearchAction[]> {
        return this.http.get<SearchAction[]>(this.sbmsUrl + "/search-actions", httpOptions);
    }
    getSearchColumns(): Observable<SearchColumn[]> {
        return this.http.get<SearchColumn[]>(this.sbmsUrl + "/search-columns", httpOptions);
    }
    getBookingsCustom(rules: SearchRule[], rows: number, offset: number): Observable<SimpleBooking[]> {
        return this.http.post<SimpleBooking[]>(this.sbmsUrl + "/bookings-custom-search/" + rows + "/" + offset, rules, httpOptions);
    }
    getBookingsCustomRecordNumber(rules: SearchRule[]): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/bookings-custom-search-record-number", rules, httpOptions);
    }

    getSimpleBookingsBySchoolId(schoolId: number): Observable<SimpleSchoolBooking[]> {
        return this.http.get<SimpleSchoolBooking[]>(this.sbmsUrl + "/simple-bookings/" + schoolId, httpOptions);
    }

    // getBookingsCustomRecordNumberTest(rules: SearchRule[]): Observable<number> {
    //     return this.http.post<number>(this.sbmsUrl + "/bookings-custom-search-record-number-test", rules, httpOptions);
    // }

    // getBookingsCustomTest(rules: SearchRule[], rows: number, offset: number): Observable<SimpleBooking[]> {
    //     return this.http.post<SimpleBooking[]>(this.sbmsUrl + "/bookings-custom-search-test/" + rows + "/" + offset, rules, httpOptions);
    // }

    getCustomBookingCsvFile(config: CustomCsvExportConfiguration): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json" }),
            responseType: "text" as "json"
        };
        return this.http.post<string>(this.sbmsUrl + "/bookings-custom-csv-export", config, httpOptions);
    }

    getCustomBookingXlsxFile(config: CustomCsvExportConfiguration): Observable<any> {
        const httpOptions = {
            withCredentials: true,
            responseType: "blob" as "json"
        };
        return this.http.post<any>(this.sbmsUrl + "/bookings-custom-xlsx-export", config, httpOptions);
    }

    getMonthlyBookingXlsxFile(month: number, year: number): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<any>(this.sbmsUrl + "/bookings-monthly-xlsx-export/" + year + "/" + month, httpOptions);
    }
    postSavedSearch(search: SavedSearch): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/saved-search", search, httpOptions);
    }
    getAllSavedSearches(): Observable<SavedSearch[]> {
        return this.http.get<SavedSearch[]>(this.sbmsUrl + "/saved-searches", httpOptions);
    }
    getPublicAndOwnedSavedSearches(): Observable<SavedSearch[]> {
        return this.http.get<SavedSearch[]>(this.sbmsUrl + "/saved-searches-public", httpOptions);
    }
    getFavoriteSavedSearches(): Observable<SavedSearch[]> {
        return this.http.get<SavedSearch[]>(this.sbmsUrl + "/saved-searches-favorite", httpOptions);
    }

    removeFavoriteSavedSearch(search: SavedSearch): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/saved-search-favorite-undo", search, httpOptions);
    }
    getSearchRulesBySavedSearchId(searchId: number): Observable<SearchRule[]> {
        return this.http.get<SearchRule[]>(this.sbmsUrl + "/search-rules/" + searchId, httpOptions);
    }
    deleteSavedSearchById(searchId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/saved-search/" + searchId, httpOptions);
    }
    getSavedSearchById(searchId: number): Observable<SavedSearch> {
        return this.http.get<SavedSearch>(this.sbmsUrl + "/saved-search/" + searchId, httpOptions);
    }
    putSavedSearch(savedSearch: SavedSearch): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/saved-search", savedSearch, httpOptions);
    }

    addSavedSearchToFavorite(searchId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/saved-search-favorite", searchId, httpOptions);
    }

    deactivateBooking(bookingId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking/deactivate/" + bookingId, null, httpOptions);
    }
    activateBooking(bookingId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking/activate/" + bookingId, null, httpOptions);
    }
    postFileForBooking(bookingId: number, fileToUpload: File): Observable<void> {
        const formData = new FormData;
        formData.append("file", fileToUpload, fileToUpload.name);
        return this.http.post<void>(this.sbmsUrl + "/upload-booking/" + bookingId, formData, httpOptions);
    }
    postSchoolInvoiceFile(invoiceId: number, fileToUpload: File): Observable<number> {
        const formData = new FormData;
        formData.append("file", fileToUpload, fileToUpload.name);
        return this.http.post<number>(this.sbmsUrl + "/upload-school-invoice-file/" + invoiceId, formData, httpOptions);
    }
    updateSchoolInvoiceFile(fileId: number, fileToUpload: File): Observable<void> {
        const formData = new FormData;
        formData.append("file", fileToUpload, fileToUpload.name);
        return this.http.put<void>(this.sbmsUrl + "/update-school-invoice-file/" + fileId, formData, httpOptions);
    }

    postEmptyFileForBooking(bookingId: number, fileType: FileType): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/upload-empty-booking-file/" + bookingId, fileType, httpOptions);
    }

    getBookingFileById(fileId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-file/" + fileId, httpOptions);
    }

    getBookingGlobalFileDataById(fileId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-global-file/" + fileId, httpOptions);
    }

    getBookingSchoolFileDataById(fileId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-school-file/" + fileId, httpOptions);
    }

    getBookingSchoolFileResponseById(fileId: number): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/booking-school-file-completed/" + fileId, httpOptions);
    }

    getGlobalFileResponseById(fileId: number): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/booking-global-file/" + fileId, httpOptions);
    }

    getIndividualFileResponseById(fileId: number): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/booking-file-completed/" + fileId, httpOptions);
    }

    getSchoolInvoiceFileById(fileId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/school-invoice-file/" + fileId, httpOptions);
    }

    getSchoolFileById(fileId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/school-file/" + fileId, httpOptions);
    }

    deleteSchoolFileById(fileId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/school-file/" + fileId, httpOptions);
    }

    updateSchoolFile(file: SchoolFile): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/school-file", file, httpOptions);
    }

    getFileNameById(fileId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "text/plain" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-file-name/" + fileId, httpOptions);
    }

    getBookingFiles(bookingId: number): Observable<BookingFile[]> {
        return this.http.get<BookingFile[]>(this.sbmsUrl + "/booking-files/" + bookingId, httpOptions);
    }

    deleteBookingFileById(fileId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-file/" + fileId, httpOptions);
    }

    getBookingReportsByBookingId(bookingId: number): Observable<BookingReport[]> {
        return this.http.get<BookingReport[]>(this.sbmsUrl + "/booking-reports/" + bookingId, httpOptions).pipe(map(reports => {
            for (let report of reports) {
                report.created = moment(report.created);
                report.sent = report.sent == null ? null : moment(report.sent);
            }
            return reports;
        }));
    }

    //attachments = school files/global files/individual files
    getBookingAttachmentsByBookingId(bookingId: number): Observable<BookingAttachmentFile[]> {
        return this.http.get<BookingAttachmentFile[]>(this.sbmsUrl + "/booking-attachment-files/" + bookingId, httpOptions);
    }

    //attachments = school files/global files/individual files that can be sent to student
    getBookingStudentAttachmentsByBookingId(bookingId: number): Observable<BookingAttachmentFile[]> {
        return this.http.get<BookingAttachmentFile[]>(this.sbmsUrl + "/booking-attachment-files-student/" + bookingId, httpOptions);
    }

    //attachments = school files/global files/individual that can be sent to school
    getBookingSchoolAttachmentsByBookingId(bookingId: number): Observable<BookingAttachmentFile[]> {
        return this.http.get<BookingAttachmentFile[]>(this.sbmsUrl + "/booking-attachment-files-school/" + bookingId, httpOptions);
    }

    postBookingReport(template: BookingReportTemplate, bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-report/" + bookingId, template, httpOptions);
    }

    getBookingReportPdfById(reportId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-report-bytes/" + reportId, httpOptions);
    }

    getBookingReportPreview(reportId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-report-preview/" + reportId, httpOptions);
    }

    getContactRequestQuotationPreview(quotationId: number, language: string): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/contact-request-quotation-preview/" + quotationId + "/" + language, httpOptions);
    }

    sendBookingReportByGmail(message: GmailMessageWithBookingFiles, reportId: number, withPastePixel: boolean): Observable<HttpResponse<string>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.post<HttpResponse<string>>(this.sbmsUrl + "/gmail-booking-report/" + reportId + "/" + withPastePixel, message, httpOptions);
    }

    sendBookingPreConfirmationByGmail(message: GmailMessageWithBookingFiles, preConfirmationId: number, fileName: string, withPastePixel: boolean): Observable<HttpResponse<string>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.post<HttpResponse<string>>(this.sbmsUrl + "/gmail-pre-confirmation/" + preConfirmationId + "/" + fileName + "/" + withPastePixel, message, httpOptions);
    }

    sendBookingConfirmationByGmail(message: GmailMessageWithBookingFiles, confirmationId: number, bookingId: number, withPastePixel: boolean): Observable<HttpResponse<string>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.post<HttpResponse<string>>(this.sbmsUrl + "/gmail-booking-confirmation/" + confirmationId + "/" + bookingId + "/" + withPastePixel, message, httpOptions);
    }

    sendBookingFinalConfirmationByGmail(message: GmailMessageWithBookingFiles, finalConfirmationId: number, bookingId: number, withPastePixel: boolean): Observable<HttpResponse<string>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.post<HttpResponse<string>>(this.sbmsUrl + "/gmail-booking-final-confirmation/" + finalConfirmationId + "/" + bookingId + "/" + withPastePixel, message, httpOptions);
    }

    getAllPaymentsReceived(): Observable<PaymentReceivedWithBooking[]> {
        return this.http.get<PaymentReceivedWithBooking[]>(this.sbmsUrl + "/payments-received", httpOptions).pipe(map(payments => {
            for (let payment of payments) {
                payment.date = moment(payment.date);
                payment.startDate = moment(payment.startDate);
                payment.endDate = moment(payment.endDate);
            }
            return payments;
        }));
    }

    getAllPaymentLineItems(): Observable<PaymentReceivedLineItem[]> {
        return this.http.get<PaymentReceivedLineItem[]>(this.sbmsUrl + "/payment-received-line-items", httpOptions);
    }

    getPaymentLineItemsByYear(year: string): Observable<PaymentReceivedLineItem[]> {
        return this.http.get<PaymentReceivedLineItem[]>(this.sbmsUrl + "/payment-received-line-items/" + year, httpOptions);
    }

    getCustomPaymentLineItems(rules: PaymentReceivedSearchRules): Observable<PaymentReceivedLineItem[]> {
        return this.http.post<PaymentReceivedLineItem[]>(this.sbmsUrl + "/payments-received-search", rules, httpOptions);
    }
    getPaymentsReceivedByRange(range: DateRange): Observable<PaymentReceivedWithBooking[]> {
        return this.http.post<PaymentReceivedWithBooking[]>(this.sbmsUrl + "/payments-received", range, httpOptions).pipe(map(payments => {
            for (let payment of payments) {
                payment.date = moment(payment.date);
                payment.startDate = moment(payment.startDate);
                payment.endDate = moment(payment.endDate);
            }
            return payments;
        }));
    }
    getPdfDocumentTemplateCssById(id: number): Observable<PdfDocumentTemplateCss> {
        return this.http.get<PdfDocumentTemplateCss>(this.sbmsUrl + "/pdf-document-template-css/" + id, httpOptions);
    }
    putPdfDocumentTemplateCss(body: PdfDocumentTemplateCss): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/pdf-document-template-css", body, httpOptions);
    }

    postBookingQuotation(quotation: BookingQuotation, bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-quotation/" + bookingId, quotation, httpOptions);
    }

    getBookingQuotationsByBookingId(bookingId: number): Observable<BookingQuotation[]> {
        return this.http.get<BookingQuotation[]>(this.sbmsUrl + "/booking-quotation/" + bookingId, httpOptions);
    }

    getBookingQuotationsWithDetailByBookingId(bookingId: number): Observable<BookingQuotationWithDetail[]> {
        return this.http.get<BookingQuotationWithDetail[]>(this.sbmsUrl + "/booking-quotation-with-total/" + bookingId, httpOptions);
    }

    postContactRequestQuotation(quotation: ContactRequestQuotation, requestId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/contact-request-quotation/" + requestId, quotation, httpOptions);
    }

    getContactRequestQuotationByRequestId(requestId: number): Observable<ContactRequestQuotationWithDetail[]> {
        return this.http.get<ContactRequestQuotationWithDetail[]>(this.sbmsUrl + "/contact-request-quotation/" + requestId, httpOptions);
    }
    getContactRequestQuotationsByBookingId(bookingId: number): Observable<ContactRequestQuotation[]> {
        return this.http.get<ContactRequestQuotation[]>(this.sbmsUrl + "/contact-request-quotation-booking/" + bookingId, httpOptions);
    }

    getContactRequestQuotationsWithDetailByBookingId(bookingId: number): Observable<ContactRequestQuotationWithDetail[]> {
        return this.http.get<ContactRequestQuotationWithDetail[]>(this.sbmsUrl + "/contact-request-quotation-with-total/" + bookingId, httpOptions);
    }

    getContactQuotationPdfById(templateId: number, quotationId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/contact-quotation-pdf-template/" + templateId + "/" + quotationId, httpOptions);
    }

    getContactRequestQuotationTemplatesByLanguage(language: Language): Observable<ContactRequestPdfTemplate[]> {
        return this.http.get<ContactRequestPdfTemplate[]>(this.sbmsUrl + "/contact-request-pdf-templates/" + language.id, httpOptions);
    }

    postContactRequestPdfTemplate(template: ContactRequestPdfTemplate): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/contact-request-pdf-template", template, httpOptions);
    }

    updateContactRequestPdfTemplate(template: ContactRequestPdfTemplate): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/contact-request-pdf-template", template, httpOptions);
    }

    getContactRequestQuotationPdfById(quotationId: number, languageName: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/contact-request-quotation-pdf/" + quotationId + "/" + languageName, httpOptions);
    }

    getSalesInvoicePdfById(invoiceId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/sales-invoice-pdf/" + invoiceId, httpOptions);
    }

    getPdfDocumentCategories(): Observable<PdfDocumentCategory[]> {
        return this.http.get<PdfDocumentCategory[]>(this.sbmsUrl + "/pdf-document-categories", httpOptions);
    }

    getBookingQuotationPdfById(quotationId: number, languageName: string): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-quotation-pdf/" + quotationId + "/" + languageName, httpOptions);
    }

    sendBookingQuotationByGmail(message: GmailMessage, quotationId: number, languageName: string): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/gmail-booking-quotation/" + quotationId + "/" + languageName, message, httpOptions);
    }
    sendContactRequestQuotationByGmail(message: GmailMessage, quotationId: number, languageName: string): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/gmail-contact-request-quotation/" + quotationId + "/" + languageName, message, httpOptions);
    }

    getContactRequests(): Observable<ContactRequest[]> {
        return this.http.get<ContactRequest[]>(this.sbmsUrl + "/contact-requests", httpOptions);
    }

    getAvailableContactRequestsToLink(): Observable<ContactRequest[]> {
        return this.http.get<ContactRequest[]>(this.sbmsUrl + "/contact-requests-available", httpOptions);
    }

    getContactRequestById(requestId: number): Observable<ContactRequest> {
        return this.http.get<ContactRequest>(this.sbmsUrl + "/contact-request/" + requestId, httpOptions).pipe(map(contactRequest => {
            if (contactRequest.dateToContact) {
                contactRequest.dateToContact = moment(contactRequest.dateToContact);
            }
            return contactRequest;
        }));
    }

    getContactRequestNew(): Observable<ContactRequest[]> {
        return this.http.get<ContactRequest[]>(this.sbmsUrl + "/contact-requests/not-processed", httpOptions);
    }

    getContactRequestProcessed(): Observable<ContactRequest[]> {
        return this.http.get<ContactRequest[]>(this.sbmsUrl + "/contact-requests/processed", httpOptions);
    }

    getContactRequestDeleted(): Observable<ContactRequest[]> {
        return this.http.get<ContactRequest[]>(this.sbmsUrl + "/contact-requests/deleted", httpOptions);
    }

    updateContactRequest(request: ContactRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/contact-request-update", request, httpOptions);
    }

    updateContactRequestWithDetail(request: ContactRequest): Observable<number> {
        return this.http.put<number>(this.sbmsUrl + "/contact-request-detail-update", request, httpOptions);
    }

    updateContactRequestUsersInCharge(requestId: number, users: UserForBackend[]): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/contact-request-users-in-charge/" + requestId, users, httpOptions);
    }

    postContactRequestComment(request: ContactRequestComment): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/contact-request-comment", request, httpOptions);
    }

    postContactRequest(request: ContactRequest): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/contact-request", request, httpOptions);
    }

    getContactRequestComments(requestId: number): Observable<ContactRequestComment[]> {
        return this.http.get<ContactRequestComment[]>(this.sbmsUrl + "/contact-request-comments/" + requestId, httpOptions);
    }

    deleteContactRequestById(requestId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/contact-request/" + requestId, httpOptions);
    }

    getQuotationRequestById(id: number): Observable<QuotationRequest> {
        return this.http.get<QuotationRequest>(this.sbmsUrl + "/quotation-request/" + id, httpOptions);
    }
    updateQuotationRequest(request: QuotationRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/quotation-request", request, httpOptions);
    }
    getAppointmentRequestById(id: number): Observable<AppointmentRequest> {
        return this.http.get<AppointmentRequest>(this.sbmsUrl + "/appointment-request/" + id, httpOptions);
    }

    getAllLeads(): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads", httpOptions);
    }
    getAllLeadsByPage(rows: number, offset: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/all-leads/" + rows + "/" + offset, httpOptions);
    }
    getLeadsByNameByPage(rows: number, offset: number, name: string): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-name/" + rows + "/" + offset + "/" + name, httpOptions);
    }
    getNewLeads(): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-not-processed", httpOptions);
    }
    getProcessedLeads(): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-processed", httpOptions);
    }
    getNewAndProcessingLeadsByPage(rows: number, offset: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-new-or-processing/" + rows + "/" + offset, httpOptions);
    }
    getDeletedLeadsByPage(rows: number, offset: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-deleted/" + rows + "/" + offset, httpOptions);
    }
    getDeletedLeads(): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-deleted", httpOptions);
    }
    getLeadsByStatusAndType(statusId: number, typeId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-by-status/" + statusId + "/" + typeId, httpOptions);
    }
    getAllLeadsByStatus(statusId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-by-status/" + statusId, httpOptions);
    }

    getAllLeadsByLeadType(typeId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-type/" + typeId, httpOptions);
    }
    getNewLeadsByLeadType(typeId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-not-processed/" + typeId, httpOptions);
    }
    getProcessedLeadsByLeadType(typeId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-processed/" + typeId, httpOptions);
    }
    getDeletedLeadsByLeadType(typeId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-deleted/" + typeId, httpOptions);
    }
    getNewAndProcessingLeadsByLeadType(typeId: number): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-new-processing/" + typeId, httpOptions);
    }
    getNewAndProcessingLeads(): Observable<Lead[]> {
        return this.http.get<Lead[]>(this.sbmsUrl + "/leads-new-processing-all", httpOptions);
    }

    getLeadTypes(): Observable<LeadType[]> {
        return this.http.get<LeadType[]>(this.sbmsUrl + "/lead-types", httpOptions);
    }

    updateLeadProcessedStatus(isProceeded: boolean, leadId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/contact-request-processed/" + isProceeded + "/" + leadId, httpOptions);
    }

    deleteContactRequestQuotation(quotationId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/contact-request-quotation-delete/" + quotationId, httpOptions);
    }

    deleteBookingQuotation(quotationId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-quotation/" + quotationId, httpOptions);
    }

    getAllProgrammeTypes(): Observable<ProgrammeType[]> {
        return this.http.get<ProgrammeType[]>(this.sbmsUrl + "/programme-types", httpOptions);
    }

    getProgrammeTypesBySchoolId(schoolId: number): Observable<ProgrammeType[]> {
        return this.http.get<ProgrammeType[]>(this.sbmsUrl + "/programme-types/" + schoolId, httpOptions);
    }

    getSchoolsByDestination(destinationId: number): Observable<School[]> {
        return this.http.get<School[]>(this.sbmsUrl + "/schools-country/" + destinationId, httpOptions);
    }

    getSchoolsWithProgrammeInformationByDestination(destinationId: number, languageId: number): Observable<School[]> {
        return this.http.get<School[]>(this.sbmsUrl + "/schools-programmes-country/" + destinationId + "/" + languageId, httpOptions);
    }

    postQuotationTemplate(template: QuotationTemplate): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/quotation-template", template, httpOptions);
    }

    getTemplatesBySchoolAndLanguage(schoolId: number, languageId: number): Observable<QuotationTemplate[]> {
        return this.http.get<QuotationTemplate[]>(this.sbmsUrl + "/quotation-templates/" + schoolId + "/" + languageId, httpOptions).pipe(map(templates => {
            for (let template of templates) {
                if (template.lastModified) {
                    template.lastModified = moment(template.lastModified);
                }
                if (template.created) {
                    template.created = moment(template.created);
                }
            }
            return templates;
        }));
    }
    getTemplatesBySchool(schoolId: number): Observable<QuotationTemplate[]> {
        return this.http.get<QuotationTemplate[]>(this.sbmsUrl + "/quotation-templates/" + schoolId, httpOptions);
    }
    getAllQuotationTemplates(): Observable<QuotationTemplate[]> {
        return this.http.get<QuotationTemplate[]>(this.sbmsUrl + "/quotation-templates", httpOptions);
    }
    getQuotationTemplateById(templateId: number): Observable<QuotationTemplate> {
        return this.http.get<QuotationTemplate>(this.sbmsUrl + "/quotation-template/" + templateId, httpOptions);
    }

    putQuotationTemplate(template: QuotationTemplateWithDetail): Observable<QuotationTemplate> {
        return this.http.put<QuotationTemplate>(this.sbmsUrl + "/quotation-template", template, httpOptions);
    }

    archiveQuotationTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/quotation-template-archive/" + templateId, httpOptions);
    }

    getSiepSalonContacts(): Observable<SiepSalonContact[]> {
        return this.http.get<SiepSalonContact[]>(this.sbmsUrl + "/siep-salon-contacts", httpOptions);
    }

    getLastInvoiceNumber(): Observable<number> {
        return this.http.get<number>(this.sbmsUrl + "/last-invoice-number", httpOptions);
    }

    postSalesInvoice(invoice: SalesInvoiceWithNewNumber): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/sales-invoice", invoice, httpOptions);
    }

    getAllVatRates(): Observable<VatRate[]> {
        return this.http.get<VatRate[]>(this.sbmsUrl + "/vat-rates", httpOptions);
    }

    getAllInvoiceReceivers(): Observable<InvoiceReceiver[]> {
        return this.http.get<InvoiceReceiver[]>(this.sbmsUrl + "/invoice-receivers", httpOptions);
    }

    postInvoiceReceiver(receiver: InvoiceReceiver): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/invoice-receiver", receiver, httpOptions);
    }

    getAllInvoices(): Observable<SalesInvoice[]> {
        return this.http.get<SalesInvoice[]>(this.sbmsUrl + "/sales-invoices", httpOptions);
    }

    getInvoiceById(id: number): Observable<SalesInvoice> {
        return this.http.get<SalesInvoice>(this.sbmsUrl + "/sales-invoice/" + id, httpOptions);
    }

    getAllPdfDocumentHeaderFooters(): Observable<PdfDocumentHeaderFooter[]> {
        return this.http.get<PdfDocumentHeaderFooter[]>(this.sbmsUrl + "/header-footers", httpOptions);
    }

    putPdfDocumentHeaderFooters(headerFooter: PdfDocumentHeaderFooter): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/header-footer", headerFooter, httpOptions);
    }

    putLogoImage(file: FormData, id: number): Observable<void> {
        const httpOptions = {
            headers: new HttpHeaders(),
            withCredentials: true
        };
        return this.http.put<void>(this.sbmsUrl + "/logo-image/" + id, file, httpOptions);
    }

    getAllPdfDocumentTemplateCsses(): Observable<PdfDocumentTemplateCss[]> {
        return this.http.get<PdfDocumentTemplateCss[]>(this.sbmsUrl + "/pdf-document-template-csses", httpOptions);
    }

    postLeadEmailTemplate(template: LeadEmailTemplate): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/lead-email-template", template, httpOptions);
    }

    getLeadEmailTemplatesByLanguage(language: Language): Observable<LeadEmailTemplate[]> {
        return this.http.get<LeadEmailTemplate[]>(this.sbmsUrl + "/lead-email-templates/" + language.id, httpOptions);
    }

    getLeadEmailTemplateById(templateId: number): Observable<LeadEmailTemplate> {
        return this.http.get<LeadEmailTemplate>(this.sbmsUrl + "/lead-email-template/" + templateId, httpOptions);
    }

    updateLeadEmailTemplate(template: LeadEmailTemplate): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/lead-email-template", template, httpOptions);
    }

    deleteLeadEmailTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/lead-email-template/" + templateId, httpOptions);
    }

    getLeadStatuses(): Observable<LeadStatus[]> {
        return this.http.get<LeadStatus[]>(this.sbmsUrl + "/lead-statuses", httpOptions);
    }

    updateLeadStatus(requestId: number, status: LeadStatus): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/lead-status/" + requestId, status, httpOptions);
    }

    approveRefundRequest(request: RefundRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/refund-request-approve", request, httpOptions);
    }

    encodeRefundPayment(request: RefundRequest): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/refund-request-paid", request, httpOptions);
    }

    getSchoolDocumentsBySchoolId(schoolId: number): Observable<SchoolDocumentFile[]> {
        return this.http.get<SchoolDocumentFile[]>(this.sbmsUrl + "/school-document-files/" + schoolId, httpOptions);
    }

    getConstantContactContactListByEmail(email: string): Observable<ConstantContactContactList> {
        return this.http.get<ConstantContactContactList>(this.sbmsUrl + "/constant-contact-contacts/" + email, httpOptions);
    }

    getEmailSignatureByUserId(userId: number): Observable<EmailSignature> {
        return this.http.get<EmailSignature>(this.sbmsUrl + "/system-user/email-signature/" + userId, httpOptions);
    }

    updateEmailSignature(signature: EmailSignature): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/email-signature", signature, httpOptions);
    }

    getSchoolContacts(schoolId: number): Observable<SchoolContact[]> {
        return this.http.get<SchoolContact[]>(this.sbmsUrl + "/school-contacts/" + schoolId, httpOptions);
    }

    getSchoolContactTypes(): Observable<SchoolContactType[]> {
        return this.http.get<SchoolContactType[]>(this.sbmsUrl + "/school-contact-types", httpOptions);
    }

    postSchoolContact(contact: SchoolContact, schoolId: number): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/school-contact/" + schoolId, contact, httpOptions);
    }

    putSchoolContact(contact: SchoolContact): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/school-contact", contact, httpOptions);
    }

    deleteSchoolContact(contactId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/school-contact/" + contactId, httpOptions);
    }

    getSchoolFilesBySchoolId(schoolId: number): Observable<SchoolFile[]> {
        return this.http.get<SchoolFile[]>(this.sbmsUrl + "/school-files/" + schoolId, httpOptions);
    }

    postSchoolFiles(formData: FormData, schoolId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/school-file/" + schoolId, formData, httpOptions);
    }

    getSchoolLviUrlsBySchoolId(schoolId: number): Observable<SchoolLviUrl[]> {
        return this.http.get<SchoolLviUrl[]>(this.sbmsUrl + "/school-lvi-urls/" + schoolId, httpOptions);
    }

    postSchoolLviUrl(data: SchoolLviUrl, schoolId: number): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/school-lvi-url/" + schoolId, data, httpOptions);
    }

    putSchoolLviUrl(data: SchoolLviUrl): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/school-lvi-url", data, httpOptions);
    }

    deleteSchoolLviUrl(id: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/school-lvi-url/" + id, httpOptions);
    }

    getAllAppointmentTypes(): Observable<AppointmentType[]> {
        return this.http.get<AppointmentType[]>(this.sbmsUrl + "/appointment-types", httpOptions);
    }

    checkIfTemplateNameExists(templateName: string, schoolId: number, languageId: number): Observable<boolean> {
        return this.http.get<boolean>(this.sbmsUrl + "/quotation-template-name/" + templateName + "/" + schoolId + "/" + languageId, httpOptions);
    }

    getAllBookingFileTypes(): Observable<BookingFileType[]> {
        return this.http.get<BookingFileType[]>(this.sbmsUrl + "/booking-file-types", httpOptions);
    }

    updateBookingFile(bookingFile: BookingFile): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-file", bookingFile, httpOptions);
    }

    updateBookingSchoolFile(schoolFile: BookingSchoolFile): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-school-file", schoolFile, httpOptions);
    }

    updateBookingGlobalFile(globalFile: BookingGlobalFile): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-global-file", globalFile, httpOptions);
    }

    deleteBookingGlobalFile(fileId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-global-file/" + fileId, httpOptions);
    }

    deleteBookingSchoolFile(fileId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-school-file/" + fileId, httpOptions);
    }

    importSchoolFilesToBooking(schoolFiles: SchoolFile[], bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-files-from-school/" + bookingId, schoolFiles, httpOptions);
    }

    importSchoolFilesToBeCompletedToBooking(schoolFiles: SchoolFile[], bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-files-to-be-completed-from-school/" + bookingId, schoolFiles, httpOptions);
    }

    getGlobalBookingFiles(): Observable<GlobalBookingFile[]> {
        return this.http.get<GlobalBookingFile[]>(this.sbmsUrl + "/global-booking-files", httpOptions);
    }

    postGlobalBookingFile(fileToUpload: File): Observable<number> {
        const formData = new FormData;
        formData.append("file", fileToUpload, fileToUpload.name);
        return this.http.post<number>(this.sbmsUrl + "/global-booking-file", formData, httpOptions);
    }

    updateGlobalBookingFile(fileInformation: GlobalBookingFile): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/global-booking-file", fileInformation, httpOptions);
    }

    getPublicBookingGlobalFileById(fileId: number, uuid: string): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/open/booking-global-file-pdf/" + fileId + "/" + uuid, httpOptions);
    }

    getGlobalBookingFileById(fileId: number): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/global-booking-file/" + fileId, httpOptions);
    }

    getIndividualBookingFileById(fileId: number, uuid: string): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/open/booking-individual-file-pdf/" + fileId + "/" + uuid, httpOptions);
    }

    deleteGlobalBookingFileById(fileId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/global-booking-file/" + fileId, httpOptions);
    }

    importGlobalFilesToBooking(globalFile: GlobalBookingFile[], bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-global-file/" + bookingId, globalFile, httpOptions);
    }

    deleteBookingReport(reportId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-report/" + reportId, httpOptions);
    }

    deleteBookingConfirmation(confirmationId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-confirmation/" + confirmationId, httpOptions);
    }

    deleteBookingFinalConfirmation(finalConfirmationId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-final-confirmation/" + finalConfirmationId, httpOptions);
    }
    postBookingEmailTemplate(template: BookingEmailTemplate): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-email-template", template, httpOptions);
    }

    getBookingEmailTemplates(): Observable<BookingEmailTemplate[]> {
        return this.http.get<BookingEmailTemplate[]>(this.sbmsUrl + "/booking-email-templates", httpOptions);
    }

    getBookingEmailTemplateById(templateId: number): Observable<BookingEmailTemplate> {
        return this.http.get<BookingEmailTemplate>(this.sbmsUrl + "/booking-email-template/" + templateId, httpOptions);
    }

    updateBookingEmailTemplate(template: BookingEmailTemplate): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-email-template", template, httpOptions);
    }

    deleteBookingEmailTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-email-template/" + templateId, httpOptions);
    }

    getBookingEmailTemplatesByLanguage(languageId: number): Observable<BookingEmailTemplate[]> {
        return this.http.get<BookingEmailTemplate[]>(this.sbmsUrl + "/booking-email-templates/" + languageId, httpOptions);
    }

    getCompletedBookingEmailTemplate(template: SimpleBookingEmailTemplate, bookingId: number): Observable<SimpleBookingEmailTemplate> {
        return this.http.post<SimpleBookingEmailTemplate>(this.sbmsUrl + "/booking-email-template-complete/" + bookingId, template, httpOptions);
    }

    getComplateContactRequestEmailTemplate(template: LeadEmailTemplate, contactRequestId: number): Observable<LeadEmailTemplate> {
        return this.http.post<LeadEmailTemplate>(this.sbmsUrl + "/contact-request-email-template/" + contactRequestId, template, httpOptions);
    }
    getComplateContactRequestEmailTemplateWithQuotation(template: LeadEmailTemplate, contactRequestId: number, quotationId: number): Observable<LeadEmailTemplate> {
        return this.http.post<LeadEmailTemplate>(this.sbmsUrl + "/contact-request-quotation-email-template/" + contactRequestId + "/" + quotationId, template, httpOptions);
    }

    getStatsLineItems(): Observable<BookingStatsLineItem[]> {
        return this.http.get<BookingStatsLineItem[]>(this.sbmsUrl + "/bookings-stats", httpOptions);
    }

    getSalesReportResult(): Observable<SalesReportResult> {
        return this.http.get<SalesReportResult>(this.sbmsUrl + "/sales-report", httpOptions);
    }

    getWeeklyBookingsForEnglishAgent(): Observable<WeeklyBookingsData[][]> {
        return this.http.get<WeeklyBookingsData[][]>(this.sbmsUrl + "/sales-report-english-agent", httpOptions);
    }

    getWeeklyBookingsForHighschool(): Observable<WeeklyBookingsData[][]> {
        return this.http.get<WeeklyBookingsData[][]>(this.sbmsUrl + "/sales-report-high-school", httpOptions);
    }

    getWeeklyBookingsForImmersion(): Observable<WeeklyBookingsData[][]> {
        return this.http.get<WeeklyBookingsData[][]>(this.sbmsUrl + "/sales-report-immersion", httpOptions);
    }

    getYearlyBookingsForAllAgents(year: number): Observable<AgentBookingData[]> {
        return this.http.get<AgentBookingData[]>(this.sbmsUrl + "/sales-report-by-agents/" + year, httpOptions);
    }

    checkInvoiceNumber(invoiceNumber: number, year: number): Observable<boolean> {
        const params = new HttpParams()
            .append("year", year)
            .append("withCredentials", true);

        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params
        };
        return this.http.post<boolean>(this.sbmsUrl + "/avi-invoice-number", invoiceNumber, httpOptions);
    }

    postAviInvoice(invoice: AviInvoice): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/avi-invoice", invoice, httpOptions);
    }

    getAvilInvoiceFileById(invoiceId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/avi-invoice-pdf/" + invoiceId, httpOptions);
    }

    postBookingPreConfirmationFile(preconf: BookingPreConfirmation, bookingId: number, languageId: number, isConfirmed: boolean, useLegacy: boolean): Observable<void> {
        const params = new HttpParams()
            .append("isConfirmed", isConfirmed.toString())
            .append("useLegacy", useLegacy.toString());
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };
        return this.http.post<void>(this.sbmsUrl + "/booking-preconf/" + bookingId + "/" + languageId, preconf, httpOptions);
    }

    getBookingPreConfirmationTemplateByLanguage(languageId: number): Observable<BookingPreConfirmationTemplate> {
        return this.http.get<BookingPreConfirmationTemplate>(this.sbmsUrl + "/preconf-templates/" + languageId, httpOptions);
    }

    getCompleteBookingPreConfirmationTemplateByLanguage(languageId: number, bookingId: number, isConfirmed: boolean): Observable<BookingPreConfirmationTemplate> {
        const params = new HttpParams()
            .append("isConfirmed", isConfirmed.toString());
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };
        return this.http.get<BookingPreConfirmationTemplate>(this.sbmsUrl + "/preconf-complete-template/" + languageId + "/" + bookingId, httpOptions);
    }

    getBookingPreConfirmationTemplates(): Observable<BookingPreConfirmationTemplate[]> {
        return this.http.get<BookingPreConfirmationTemplate[]>(this.sbmsUrl + "/preconf-templates", httpOptions);
    }

    getBookingPreConfirmationTemplateById(templateId: number): Observable<BookingPreConfirmationTemplate> {
        return this.http.get<BookingPreConfirmationTemplate>(this.sbmsUrl + "/preconf-template/" + templateId, httpOptions);
    }

    updateBookingPreConfirmationTemplate(template: BookingPreConfirmationTemplate): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/preconf-template", template, httpOptions);
    }

    getSimpleBookingPreConfirmationsByBookingId(bookingId: number): Observable<SimpleBookingPreConfirmation[]> {
        return this.http.get<SimpleBookingPreConfirmation[]>(this.sbmsUrl + "/booking-preconfs/" + bookingId, httpOptions);
    }

    getBookingPreConfirmationPdfBlob(preconfId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-preconf-pdf/" + preconfId, httpOptions);
    }

    getBookingPreConfirmationFileName(preconfId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "text/plain" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-preconf-filename/" + preconfId, httpOptions);
    }

    getBookingConfirmationPdfBlob(confirmationId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-confirmation-pdf/" + confirmationId, httpOptions);
    }

    getBookingFinalConfirmationPdfBlob(finalConfirmationId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/booking-final-confirmation-pdf/" + finalConfirmationId, httpOptions);
    }

    deleteBookingPreConfirmation(preconfId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-preconf-delete/" + preconfId, httpOptions);
    }

    getAllLviBankInformations(): Observable<LviBankInformation[]> {
        return this.http.get<LviBankInformation[]>(this.sbmsUrl + "/bank-informations", httpOptions);
    }

    getAllInvoicesWithPayments(): Observable<SchoolInvoiceWithPayments[]> {
        return this.http.get<SchoolInvoiceWithPayments[]>(this.sbmsUrl + "/school-invoices", httpOptions);
    }

    getLeadsByLeadType(limit: number, offset: number, typeId: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-type/" + typeId + "/" + limit + "/" + offset, httpOptions);
    }
    getLeadsByScool(rows: number, offset: number, schoolId: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-school/" + rows + "/" + offset + "/" + schoolId, httpOptions);
    }
    getLeadsByStatus(rows: number, offset: number, statusId: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-status/" + rows + "/" + offset + "/" + statusId, httpOptions);
    }
    getLeadsByDestination(rows: number, offset: number, destinationId: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-destination/" + rows + "/" + offset + "/" + destinationId, httpOptions);
    }
    getLeadsByPhoneNumber(rows: number, offset: number, phoneNumber: string): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-phone-number/" + rows + "/" + offset + "/" + phoneNumber, httpOptions);
    }
    getLeadsByEmail(rows: number, offset: number, email: string): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-email/" + rows + "/" + offset + "/" + email, httpOptions);
    }
    getLeadsByLanguage(rows: number, offset: number, languageId: number): Observable<LeadSearchResult> {
        return this.http.get<LeadSearchResult>(this.sbmsUrl + "/leads-by-language/" + rows + "/" + offset + "/" + languageId, httpOptions);
    }
    getLeadsByMultiFilters(searchOptions: LeadSearchOptions, rows: number, offset: number): Observable<LeadSearchResult> {
        return this.http.post<LeadSearchResult>(this.sbmsUrl + "/leads-by-filters/" + rows + "/" + offset, searchOptions, httpOptions);
    }
    getWpBookingRequestsByMultiFilters(searchOptions: WpBookingRequestSearchOptions, rows: number, offset: number): Observable<WpBookingRequest[]> {
        return this.http.post<WpBookingRequest[]>(this.sbmsUrl + "/wp-booking-requests/" + rows + "/" + offset, searchOptions, httpOptions).pipe(map(
            requests => {
                for (let request of requests) {
                    request.startDay = moment(request.startDay);
                    request.endDay = moment(request.endDay);
                    request.created = moment(request.created);
                    request.duration = Math.round(request.endDay.diff(request.startDay, "days") / 7);
                }
                return requests;
            }
        ));
    }
    getWpBookingRequestNumberByMultiFilters(searchOptions: WpBookingRequestSearchOptions): Observable<number> {
        return this.http.post<number>(this.sbmsUrl + "/wp-booking-requests-number", searchOptions, httpOptions);
    }

    getSimpleBookingsSearchResult(rows: number, offset: number): Observable<any> {
        return this.http.get<any>(this.sbmsUrl + "/test-bookings-all/" + rows + "/" + offset, { withCredentials: true });
    }

    getContactRequestEmailHistoryByRequestId(requestId: number): Observable<ContactRequestEmailHistory[]> {
        return this.http.get<ContactRequestEmailHistory[]>(this.sbmsUrl + "/lead-email-history/" + requestId, httpOptions);
    }

    getBookingEmailHistoryByBookingId(bookingId: number): Observable<BookingEmailHistory[]> {
        return this.http.get<BookingEmailHistory[]>(this.sbmsUrl + "/booking-email-history/" + bookingId, httpOptions).pipe(map(histories => {
            for (let history of histories) {
                history.email.sentDateTime = history.email.sentDateTime == null ? null : moment(history.email.sentDateTime);
                if (history.email.openedAt) {
                    history.email.openedAt = moment(history.email.openedAt);
                }
            }
            return histories;
        }));
    }

    getBookingRequestEmailHistoryByRequestId(requestId: number): Observable<EmailHistory[]> {
        return this.http.get<EmailHistory[]>(this.sbmsUrl + "/booking-request-email-history/" + requestId, httpOptions).pipe(map(histories => {
            for (let history of histories) {
                history.sentDateTime = history.sentDateTime == null ? null : moment(history.sentDateTime);
                if (history.openedAt) {
                    history.openedAt = moment(history.openedAt);
                }
            }
            return histories;
        }));
    }

    getEmailSignaturesByUser(): Observable<EmailSignature[]> {
        return this.http.get<EmailSignature[]>(this.sbmsUrl + "/email-signatures", httpOptions);
    }

    postEmailSignature(signature: EmailSignature): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/email-signature", signature, httpOptions);
    }

    getStudentContactTypes(): Observable<StudentContactType[]> {
        return this.http.get<StudentContactType[]>(this.sbmsUrl + "/student-contact-types", httpOptions);
    }

    getStudentContactsByStudentId(studentId: number): Observable<StudentContact[]> {
        return this.http.get<StudentContact[]>(this.sbmsUrl + "/student-contacts/" + studentId, httpOptions);
    }

    deleteStudentContactById(contactId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/student-contact/" + contactId, httpOptions);
    }

    deleteTravelById(travelId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/travel/" + travelId, httpOptions);
    }

    getUsersByBookingId(bookingId: number): Observable<SimpleUser[]> {
        return this.http.get<SimpleUser[]>(this.sbmsUrl + "/booking-users/" + bookingId, httpOptions);
    }

    putAssignedUsersToBooking(users: SimpleUser[], bookingId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-users/" + bookingId, users, httpOptions);
    }

    getMonthlyVatCsv(month: number, year: number, option: number): Observable<any> {
        return this.http.get<any>(this.sbmsUrl + "/monthly-revenue/" + month + "/" + year + "/" + option, { withCredentials: true, observe: "response" as "body", responseType: "text" as "json" });
    }
    getMonthlyVatXlsx(month: number, year: number, option: number): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<any>(this.sbmsUrl + "/monthly-revenue/" + month + "/" + year + "/" + option, httpOptions);
    }

    getWeeklyReportCsv(): Observable<any> {
        return this.http.get<any>(this.sbmsUrl + "/bookings-weekly-stats-csv", { withCredentials: true, observe: "response" as "body", responseType: "text" as "json" });
    }

    getStudentEmailListCsv(): Observable<HttpResponse<string>> {
        return this.http.get<HttpResponse<string>>(this.sbmsUrl + "/student-email-export", { withCredentials: true, observe: "response" as "body", responseType: "text" as "json" });
    }

    getProductToReportCsv(baseYear: number): Observable<HttpResponse<string>> {
        return this.http.get<HttpResponse<string>>(this.sbmsUrl + "/product-to-report-csv/" + baseYear, { withCredentials: true, observe: "response" as "body", responseType: "text" as "json" });
    }

    getSchoolsByProgrammeName(programmeName: string): Observable<School[]> {
        return this.http.post<School[]>(this.sbmsUrl + "/schools-programme-name", programmeName, httpOptions);
    }

    postWpBookingRequestComment(comment: WpBookingRequestComment, requestId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/wp-booking-request-comment/" + requestId, comment, httpOptions);
    }

    getWpBookingRequestCommentsByRequestId(requestId: number): Observable<WpBookingRequestComment[]> {
        return this.http.get<WpBookingRequestComment[]>(this.sbmsUrl + "/wp-booking-request-comments/" + requestId, httpOptions);
    }

    putWpBookingRequestComment(comment: WpBookingRequestComment): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/wp-booking-request-comment", comment, httpOptions);
    }

    deleteWpBookingRequestComment(commentId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/wp-booking-request-comment/" + commentId, httpOptions);
    }

    postProgrammeInformations(informations: ProgrammeInformation[], schoolId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/programme-information/" + schoolId, informations, httpOptions);
    }

    getProgrammeInformationsBySchoolAndLanguage(schoolId: number, languageId: number): Observable<ProgrammeInformation[]> {
        return this.http.get<ProgrammeInformation[]>(this.sbmsUrl + "/programme-informations/" + schoolId + "/" + languageId, httpOptions);
    }

    getProgrammeInformationsBySchoolId(schoolId: number): Observable<ProgrammeInformation[]> {
        return this.http.get<ProgrammeInformation[]>(this.sbmsUrl + "/programme-informations/" + schoolId, httpOptions);
    }

    getBookingPreConfirmationPreview(preconfId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-pre-confirmation-preview/" + preconfId, httpOptions);
    }

    getBookingRequestIdByBookingId(bookingId: number): Observable<number> {
        return this.http.get<number>(this.sbmsUrl + "/booking-request-booking-id/" + bookingId, httpOptions);
    }

    postPaymentToSupplier(payment: PaymentToSupplier, bookingId: number, orderId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/payment-supplier/" + bookingId + "/" + orderId, payment, httpOptions);
    }

    putPaymentToSupplier(payment: PaymentToSupplier, bookingId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/payment-supplier/" + bookingId, payment, httpOptions);
    }

    getPaymentsToSupplierByBookingId(bookingId: number): Observable<PaymentToSupplier[]> {
        return this.http.get<PaymentToSupplier[]>(this.sbmsUrl + "/payments-supplier/" + bookingId, httpOptions).pipe(map(
            payments => {
                for (let payment of payments) {
                    if (payment.created) {
                        payment.created = moment(payment.created);
                    }
                    payment.amount = new Decimal(payment.amount);
                    payment.date = moment(payment.date);
                    payment.hidden = true;
                }
                return payments;
            }
        ));
    }

    getBookingTempUserLogByBookingId(bookingId: number): Observable<BookingTempUserLog[]> {
        return this.http.get<BookingTempUserLog[]>(this.sbmsUrl + "/booking-user-log/" + bookingId, httpOptions);
    }

    getGoogleSheetUrl(schoolId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/school-google-sheet-url/" + schoolId, httpOptions);
    }

    updateUserMainLanguage(language: Language): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/system-user/main-language", language, httpOptions);
    }

    updateDefaultLeadFilter(enabled: boolean): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/system-user/default-lead-filter", enabled, httpOptions);
    }

    getBookingStatuses(): Observable<BookingStatus[]> {
        return this.http.get<BookingStatus[]>(this.sbmsUrl + "/booking-statuses/en", httpOptions);
    }

    getPublicBookingStatuses(localId: string): Observable<BookingStatus[]> {
        return this.http.get<BookingStatus[]>(this.sbmsUrl + "/open/booking-statuses/" + localId);
    }

    getBookingStatusByBookingId(bookingId: number): Observable<BookingStatus> {
        return this.http.get<BookingStatus>(this.sbmsUrl + "/booking-status-booking/" + bookingId, httpOptions);
    }

    getBookingStatusByUuid(uuid: string, localId: string): Observable<BookingStatus> {
        return this.http.get<BookingStatus>(this.sbmsUrl + "/open/booking-status/" + uuid + "/" + localId);
    }

    postBookingClientFile(uuid: string, formData: FormData): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/booking-client-file/" + uuid, formData);
    }

    postBookingSchoolFileResponse(uuid: string, formData: FormData, fileId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/booking-school-file-completed/" + fileId + "/" + uuid, formData);
    }

    postBookingGlobalFileResponse(uuid: string, formData: FormData, fileId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/booking-global-file-completed/" + fileId + "/" + uuid, formData);
    }

    postBookingIndividualFileResponse(uuid: string, formData: FormData, fileId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/open/booking-individual-file-completed/" + fileId + "/" + uuid, formData);
    }

    getBookingClientFilesByUuid(uuid: string): Observable<BookingClientFileOpen[]> {
        return this.http.get<BookingClientFileOpen[]>(this.sbmsUrl + "/open/booking-client-files/" + uuid);
    }

    getBookingClientFilesByBookingId(bookingId: number): Observable<BookingClientFile[]> {
        return this.http.get<BookingClientFile[]>(this.sbmsUrl + "/booking-client-files/" + bookingId, httpOptions);
    }

    getSchoolInvoicesWithPaymentOrders(): Observable<SchoolInvoiceWithPaymentOrdersListItem[]> {
        return this.http.get<SchoolInvoiceWithPaymentOrdersListItem[]>(this.sbmsUrl + "/school-invoices-with-payments", httpOptions);
    }

    getSchoolInvoicesWithPaymentByYear(year: string): Observable<SchoolInvoiceWithPaymentOrdersListItem[]> {
        return this.http.get<SchoolInvoiceWithPaymentOrdersListItem[]>(this.sbmsUrl + "/school-invoices-with-payments/" + year, httpOptions);
    }

    getSchoolInvoiceYears(): Observable<string[]> {
        return this.http.get<string[]>(this.sbmsUrl + "/school-invoice-years", httpOptions);
    }

    getBookingClientFileById(fileId: number): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/booking-client-file/" + fileId, httpOptions);
    }

    getBookingClientPublicFileById(fileId: number, uuid: string): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/open/booking-client-file-data/" + fileId + "/" + uuid, httpOptions);
    }

    getPublicBookingSchoolFileById(fileId: number, uuid: string): Observable<HttpResponse<Blob>> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<HttpResponse<Blob>>(this.sbmsUrl + "/open/booking-school-file-pdf/" + fileId + "/" + uuid, httpOptions);
    }

    updateBookingClientFile(file: BookingClientFile): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-client-file", file, httpOptions);
    }

    postAuthenticatedBookingChat(chat: BookingChat, bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-chat/" + bookingId, chat, httpOptions);
    }

    verifyRecaptcha(resopnse: RecaptchaUserResponse): Observable<any> {
        return this.http.post<any>(this.sbmsUrl + "/open/recaptcha", resopnse, httpOptions);
    }

    getBookingChats(uuid: string): Observable<BookingChat[]> {
        return this.http.get<BookingChat[]>(this.sbmsUrl + "/open/booking-chats/" + uuid, httpOptions);
    }

    getBookingChatsByBookingId(bookingId: number): Observable<BookingChat[]> {
        return this.http.get<BookingChat[]>(this.sbmsUrl + "/booking-chats/" + bookingId, httpOptions);
    }

    getOpenBookingInformationByUuid(uuid: string, languageName: string): Observable<OpenBookingInformation> {
        return this.http.get<OpenBookingInformation>(this.sbmsUrl + "/open/booking-information/" + languageName + "/" + uuid, httpOptions);
    }

    getBookingSchoolFiles(bookingId: number): Observable<BookingSchoolFile[]> {
        return this.http.get<BookingSchoolFile[]>(this.sbmsUrl + "/booking-school-files/" + bookingId, httpOptions);
    }

    getAllFileTypes(): Observable<FileType[]> {
        return this.http.get<FileType[]>(this.sbmsUrl + "/file-types", httpOptions);
    }

    getBookingGlobalFiles(bookingId: number): Observable<BookingGlobalFile[]> {
        return this.http.get<BookingGlobalFile[]>(this.sbmsUrl + "/booking-global-files/" + bookingId, httpOptions);
    }

    getOpenSchoolFilesToCompleteByUuid(uuid: string): Observable<OpenSchoolFile[]> {
        return this.http.get<OpenSchoolFile[]>(this.sbmsUrl + "/open/booking-school-files-to-complete/" + uuid, httpOptions);
    }

    getOpenGlobalFilesToCompleteByUuid(uuid: string): Observable<OpenGlobalFile[]> {
        return this.http.get<OpenGlobalFile[]>(this.sbmsUrl + "/open/booking-global-files-to-complete/" + uuid, httpOptions);
    }

    getOpenBookingFilesByUuid(uuid: string): Observable<OpenBookingFile[]> {
        return this.http.get<OpenBookingFile[]>(this.sbmsUrl + "/open/booking-files/" + uuid, httpOptions);
    }

    getOpenBookingFilesToCompleteByUuid(uuid: string): Observable<OpenBookingFile[]> {
        return this.http.get<OpenBookingFile[]>(this.sbmsUrl + "/open/booking-files-to-be-completed/" + uuid, httpOptions);
    }

    postBookingConfirmation(template: BookingConfirmationTemplate, bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/post-booking-confirmation/" + template.id, bookingId, httpOptions);
    }

    getBookingConfirmations(bookingId: number): Observable<BookingConfirmation[]> {
        return this.http.get<BookingConfirmation[]>(this.sbmsUrl + "/booking-confirmations/" + bookingId, httpOptions);
    }

    postBookingFinalConfirmation(template: BookingFinalConfirmationTemplate, bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/post-booking-final-confirmation/" + template.id, bookingId, httpOptions);
    }

    postModifiedFinalConfirmation(body: string, templateId: number, bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/post-booking-final-confirmation-modified/" + templateId + "/" + bookingId, body, httpOptions);
    }

    getBookingFinalConfirmations(bookingId: number): Observable<BookingFinalConfirmation[]> {
        return this.http.get<BookingFinalConfirmation[]>(this.sbmsUrl + "/booking-final-confirmations/" + bookingId, httpOptions);
    }

    getBookingConfirmationHtmlString(confirmationId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-confirmation-preview/" + confirmationId, httpOptions);
    }

    getBookingFinalConfirmationHtmlString(finalConfirmationId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-final-confirmation-preview/" + finalConfirmationId, httpOptions);
    }

    getAllTravelRequestCodes(): Observable<TravelRequestCode[]> {
        return this.http.get<TravelRequestCode[]>(this.sbmsUrl + "/travel-request-codes", httpOptions);
    }

    getSchoolCountryConsistency(schoolId: number, countryId: number): Observable<boolean> {
        return this.http.get<boolean>(this.sbmsUrl + "/school-country/" + schoolId + "/" + countryId, httpOptions);
    }

    getAllMotherLanguages(): Observable<MotherLanguage[]> {
        return this.http.get<MotherLanguage[]>(this.sbmsUrl + "/mother-languages", httpOptions);
    }

    setDepositPaidDate(bookingId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-deposit-paid", bookingId, httpOptions);
    }

    updateBookingAccommodation(accommodation: Accommodation, bookingId: number): Observable<number> {
        return this.http.put<number>(this.sbmsUrl + "/booking-accommodation/" + bookingId, accommodation, httpOptions);
    }

    getTravelInsuranceSuppliers(): Observable<InsuranceSupplier[]> {
        return this.http.get<InsuranceSupplier[]>(this.sbmsUrl + "/travel-insurance-suppliers", httpOptions);
    }
    getCancellationInsuranceSuppliers(): Observable<InsuranceSupplier[]> {
        return this.http.get<InsuranceSupplier[]>(this.sbmsUrl + "/cancellation-insurance-suppliers", httpOptions);
    }

    getSchoolInvoiceListItemsByYear(year: number): Observable<SchoolInvoiceListItem[]> {
        return this.http.get<SchoolInvoiceListItem[]>(this.sbmsUrl + "/school-invoices-by-year/" + year, httpOptions);
    }

    getPaymentToSchoolListItemsByYear(year: number): Observable<PaymentToSchoolListItem[]> {
        return this.http.get<PaymentToSchoolListItem[]>(this.sbmsUrl + "/payment-to-school-by-year/" + year, httpOptions).pipe(map(items => {
            for (let item of items) {
                item.paidDate = moment(item.paidDate);
                item.paidMonth = item.paidDate.month() + 1;
            }
            return items;
        }));
    }

    getRedirectUrlForGoogleOauth2ConsentScreen(): Observable<string> {
        const httpOptions = {
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(environment.googleOauthConsentUrl, httpOptions);
    }

    postEmailWithNewFlow(message: GmailMessage): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/gmail-with-new-flow", message, httpOptions);
    }

    getEmailAddress(): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/system-user/email", httpOptions);
    }

    getAllBookingsWithUsers(): Observable<BookingWithUsers[]> {
        return this.http.get<BookingWithUsers[]>(this.sbmsUrl + "/bookings-with-users", httpOptions);
    }

    getAllSimpleUsers(): Observable<SimpleUser[]> {
        return this.http.get<SimpleUser[]>(this.sbmsUrl + "/simple-users", httpOptions);
    }

    postGroupBooking(booking: GroupBookingPost): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/booking-group", booking, httpOptions);
    }

    getAllBookingGroups(): Observable<GroupBookingListItem[]> {
        return this.http.get<GroupBookingListItem[]>(this.sbmsUrl + "/booking-groups", httpOptions);
    }

    getGroupBookingById(groupId: number): Observable<GroupBookingWithDetail> {
        return this.http.get<GroupBookingWithDetail>(this.sbmsUrl + "/booking-group/" + groupId, httpOptions);
    }

    getBookingFinancialState(bookingId: number, currencyId: number): Observable<FinancialStateJsonContainer> {
        return this.http.get<FinancialStateJsonContainer>(this.sbmsUrl + "/booking-financial-state/" + bookingId + "/" + currencyId, httpOptions);
    }
    getBrazilianFinancialState(bookingId: number, currencyId: number): Observable<BrazilianFinancialState> {
        return this.http.get<BrazilianFinancialState>(this.sbmsUrl + "/brazilian-financial-state/" + bookingId + "/" + currencyId, httpOptions);
    }

    getBookingIdByLvmsId(lvmsId: number): Observable<number> {
        return this.http.get<number>(this.sbmsUrl + "/booking-id/" + lvmsId, httpOptions);
    }

    putBookingGroup(group: GroupBookingWithDetail): Observable<GroupBookingWithDetail> {
        return this.http.put<GroupBookingWithDetail>(this.sbmsUrl + "/booking-group", group, httpOptions);
    }

    getRecentSimpleBookingItems(): Observable<SimpleBookingItem[]> {
        return this.http.get<SimpleBookingItem[]>(this.sbmsUrl + "/simple-booking-items", httpOptions);
    }

    postVivawalletPaymentOrder(paymentOrder: VivawalletPaymentOrderPost): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.post<string>(this.sbmsUrl + "/vivawallet-payment-order", paymentOrder, httpOptions);
    }

    postVivawalletPaymentNotification(notification: VivawalletPaymentNotification): Observable<any> {
        return this.http.post<any>(this.sbmsUrl + "/open/vivawallet-payment-notification", notification, httpOptions);
    }

    getVivawalletOrderInformation(bookingId: number): Observable<VivawalletPaymentOrderPost> {
        return this.http.get<VivawalletPaymentOrderPost>(this.sbmsUrl + "/vivawallet-verify-amount/" + bookingId, httpOptions);
    }

    getVivawalletPaymentOrders(bookingId: number): Observable<VivawalletPaymentOrderInfo[]> {
        return this.http.get<VivawalletPaymentOrderInfo[]>(this.sbmsUrl + "/vivawallet-payment-orders/" + bookingId, httpOptions);
    }

    getBookingRequestComment(bookingId: number): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "text/plain" }),
            responseType: "text" as "json",
            withCredentials: true
        };
        return this.http.get<string>(this.sbmsUrl + "/booking-request-comment/" + bookingId, httpOptions);
    }

    //Deprecated. moved to archiveQuotationTemplate
    deleteQuotationTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/quotation-template-delete/" + templateId, httpOptions);
    }

    deleteBookingConfirmationTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-confirmation-template/" + templateId, httpOptions);
    }

    deleteBookingReportTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-report-template/" + templateId, httpOptions);
    }

    deleteBookingFinalConfirmationTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/booking-final-confirmation-template/" + templateId, httpOptions);
    }

    deleteContactRequestReportTemplate(templateId: number): Observable<void> {
        return this.http.delete<void>(this.sbmsUrl + "/contact-request-pdf-template/" + templateId, httpOptions);
    }

    getCompletePaymentDate(bookingId: number): Observable<Date> {
        return this.http.get<Date>(this.sbmsUrl + "/booking-complete-payment-date/" + bookingId, httpOptions);
    }

    updateBookingSalesAgent(bookingId: number, salesAgent: SalesAgent): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/booking-sales-agent/" + bookingId, salesAgent, httpOptions);
    }

    testErrorMessage(): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/paste-pixel-error", null, httpOptions);
    }

    getMyBookings(): Observable<MyBooking[]> {
        return this.http.get<MyBooking[]>(this.sbmsUrl + "/my-bookings", httpOptions).pipe(map(bookings => {
            for (let booking of bookings) {
                booking.startDate = new Date(booking.startDate);
                booking.endDate = new Date(booking.endDate);
                booking.totalReceivedInEuro = new Decimal(booking.totalReceivedInEuro);
                booking.remainingBalanceInEuro = new Decimal(booking.remainingBalanceInEuro);
            }
            return bookings;
        }));
    }

    sendEmailToBookingRequest(message: GmailMessageWithOption, requestId: number, signatureId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/oauth2-gmail-html-booking-request/" + requestId + "/" + signatureId, message, httpOptions);
    }

    getReminderCount(): Observable<number> {
        return this.http.get<number>(this.sbmsUrl + "/count-payment-reminders", httpOptions);
    }

    getPaymentReminders(): Observable<PaymentReminder[]> {
        return this.http.get<PaymentReminder[]>(this.sbmsUrl + "/payment-reminders", httpOptions);
    }

    dismissPaymentReminder(reminderId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/dismiss-payment-reminder/" + reminderId, httpOptions);
    }

    disablePaymentReminder(reminderId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/disable-payment-reminder/" + reminderId, httpOptions);
    }

    getStudentReminderInfoByBookingId(bookingId: number): Observable<StudentReminderInfo> {
        return this.http.get<StudentReminderInfo>(this.sbmsUrl + "/booking-reminder-info/" + bookingId, httpOptions);
    }

    getPaymentReminderTemplates(): Observable<PaymentReminderTemplate[]> {
        return this.http.get<PaymentReminderTemplate[]>(this.sbmsUrl + "/payment-reminder-templates", httpOptions);
    }

    updatePaymentReminderTemplates(templates: PaymentReminderTemplate[]): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/payment-reminder-templates", templates, httpOptions);
    }

    getBookingEmailTemplateListItems(): Observable<BookingEmailTemplateListItem[]> {
        return this.http.get<BookingEmailTemplateListItem[]>(this.sbmsUrl + "/booking-email-template-list", httpOptions);
    }

    sendPaymentReminderByEmail(reminderInfo: PaymentReminderPost): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/payment-reminder", reminderInfo, httpOptions);
    }

    getAllAviInvoices(): Observable<AviInvoiceListItem[]> {
        return this.http.get<AviInvoiceListItem[]>(this.sbmsUrl + "/all-avi-invoices", httpOptions);
    }

    appendGoogleSpreadSheet(bookingId: number): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/spread-sheet-append", bookingId, httpOptions);
    }

    getAllConstantContactCampaigns(): Observable<ConstantContactCampaignListItem[]> {
        return this.http.get<ConstantContactCampaignListItem[]>(this.sbmsUrl + "/constant-contact-campaigns", httpOptions);
    }

    getConstantContactCampaignDetail(campaignId: string): Observable<ConstantContactCampaignDetail> {
        return this.http.get<ConstantContactCampaignDetail>(this.sbmsUrl + "/constant-contact-campaign-detail/" + campaignId, httpOptions);
    }

    getBrevoContactByEmail(email: string, firstName: string, lastName: string): Observable<BrevoContact> {
        const params = new HttpParams()
            .append("firstName", firstName)
            .append("lastName", lastName);
        const headers = new HttpHeaders();
        const httpOptions = {
            headers: headers,
            params: params,
            withCredentials: true
        };
        return this.http.get<BrevoContact>(this.sbmsUrl + "/brevo-contact/" + email, httpOptions);
    }

    getBrevoLists(): Observable<BrevoListsContainer> {
        return this.http.get<BrevoListsContainer>(this.sbmsUrl + "/brevo-lists", httpOptions);
    }

    updateBrevoContact(contact: BrevoContact, email: string): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/brevo-contact/" + email, contact, httpOptions);
    }

    //get booking ids between 2 years ago and now
    getRecentBookingIds(): Observable<BookingIdListItem[]> {
        return this.http.get<BookingIdListItem[]>(this.sbmsUrl + "/bookings-recent-ids", httpOptions);
    }

    getStudentNameByBookingIdList(bookingIds: number[]): Observable<string> {
        return this.http.post<string>(this.sbmsUrl + "/booking-ids-student-name", bookingIds, stringHttpOptions);
    }

    getSalesAgentCommissionByBookingId(bookingId: number): Observable<any> {
        return this.http.get<any>(this.sbmsUrl + "/agent-commission/" + bookingId, httpOptions);
    }

    getSalesAgentCommissions(): Observable<AgentCommissionListItem[]> {
        return this.http.get<AgentCommissionListItem[]>(this.sbmsUrl + "/agent-commissions", httpOptions).pipe(map((list: AgentCommissionListItem[]) => {
            list.map(item => {
                item.startDate = moment(item.startDate);
                item.endDate = moment(item.endDate);
            });
            return list;
        }));
    }

    getSchoolInvoicesToValidate(year: number): Observable<SchoolInvoiceToValidate[]> {
        return this.http.get<SchoolInvoiceToValidate[]>(this.sbmsUrl + "/school-invoices-to-validate/" + year, httpOptions).pipe(map((invoices: SchoolInvoiceToValidate[]) => {
            invoices.map(invoice => {
                invoice.date = moment(invoice.date);
            });
            return invoices;
        }));
    }

    getCustomLinks(): Observable<CustomLink[]> {
        const res: CustomLink[] = [];
        return of(res);
        // return this.http.get<CustomLink[]>(this.sbmsUrl + "/custom-links", httpOptions);
    }

    updateAgentCommissionPaidStatus(bookingId: number, isPaid: boolean): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/agent-commission-paid/" + bookingId, isPaid, httpOptions);
    }

    getAgentCommissionAvailableBookingIds(): Observable<number[]> {
        return this.http.get<number[]>(this.sbmsUrl + "/agent-commission-booking-ids", httpOptions);
    }

    postAgentCommissionPayment(payment: AgentCommissionPayment): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/agent-commission-payment", payment, httpOptions);
    }

    getGeneralSuppliers(): Observable<GeneralSupplier[]> {
        return this.http.get<GeneralSupplier[]>(this.sbmsUrl + "/general-suppliers", httpOptions);
    }

    getGeneralSupplierPaymentTypes(): Observable<GeneralSupplierPaymentType[]> {
        return this.http.get<GeneralSupplierPaymentType[]>(this.sbmsUrl + "/general-supplier-payment-types", httpOptions);
    }

    postGeneralSupplierInvoice(invoice: GeneralSupplierInvoice, invoiceFile: File, paidByCode: number): Observable<void> {
        const formData: FormData = new FormData();
        formData.append('file', invoiceFile, invoiceFile.name);
        formData.append('json', JSON.stringify(invoice));
        return this.http.post<void>(this.sbmsUrl + "/general-supplier-invoice/" + paidByCode, formData, {
            headers: new HttpHeaders(),
            withCredentials: true
        });
    }


    postGeneralSupplierUnpaidInvoice(invoice: GeneralSupplierUnpaidInvoice, invoiceFile: File): Observable<void> {
        const formData: FormData = new FormData();
        formData.append('file', invoiceFile, invoiceFile.name);
        formData.append('json', JSON.stringify(invoice));
        return this.http.post<void>(this.sbmsUrl + "/general-supplier-unpaid-invoice", formData, {
            headers: new HttpHeaders(),
            withCredentials: true
        });
    }

    getGeneralSupplierInvoices(): Observable<GeneralSupplierInvoice[]> {
        return this.http.get<GeneralSupplierInvoice[]>(this.sbmsUrl + "/general-supplier-invoices", httpOptions);
    }

    getGeneralSupplierUnpaidInvoices(): Observable<GeneralSupplierUnpaidInvoice[]> {
        return this.http.get<GeneralSupplierUnpaidInvoice[]>(this.sbmsUrl + "/general-supplier-unpaid-invoices", httpOptions);
    }

    getGeneralSupplierUnpaidInvoicesById(invoiceId: number): Observable<GeneralSupplierUnpaidInvoice> {
        return this.http.get<GeneralSupplierUnpaidInvoice>(this.sbmsUrl + "/general-supplier-unpaid-invoice/" + invoiceId, httpOptions).pipe(map((invoice) => {
            invoice.amount = new Decimal(invoice.amount);
            invoice.date = moment(invoice.date);
            return invoice;
        }
        ));
    }

    updateGeneralSupplierUnpaidInvoiceValidationStatus(invoiceId: number, isValidated: boolean): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/general-supplier-unpaid-invoice-validate/" + invoiceId + "/" + isValidated, null, httpOptions);
    }

    updateGeneralSupplierUnpaidInvoice(invoice: GeneralSupplierUnpaidInvoice): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/general-supplier-unpaid-invoice", invoice, httpOptions);
    }

    getGeneralSupplierInvoiceFileData(invoiceId: number): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders(),
            responseType: "blob" as "json",
            withCredentials: true
        };
        return this.http.get<Blob>(this.sbmsUrl + "/general-supplier-invoice-file/" + invoiceId, httpOptions);
    }

    postGeneralSupplier(supplier: GeneralSupplier): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/general-supplier", supplier, httpOptions);
    }

    markGeneralSupplierInvoiceAsPaid(invoiceId: number): Observable<void> {
        return this.http.put<void>(this.sbmsUrl + "/general-supplier-unpaid-invoice/" + invoiceId, null, httpOptions);
    }

    logout(): Observable<void> {
        return this.http.post<void>(this.sbmsUrl + "/auth/logout", null, { withCredentials: true, responseType: 'text' as 'json' });
    }

    testRoles(): Observable<void> {
        return this.http.get<void>(this.sbmsUrl + "/auth/roles", httpOptions);
    }

    getUserInfo(): Observable<UserInfo> {
        return this.http.get<UserInfo>(this.sbmsUrl + "/auth/me", httpOptions);
    }

    getCsrfToken(): Observable<void> {
        return this.http.get<void>(this.sbmsUrl + "/csrf-token", { withCredentials: true });
    }

}